// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==============================
   Kitchen Display System Styles
   ============================== */

/* ===== Layout ===== */
.kds-screen-layout {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 174px);
  overflow: hidden;
  /* width: 100%; */
  box-sizing: border-box;

  /* Font scaling: every KDS font size adds --kds-font-delta (set on <html> by the
     Font Change menu: Small -2px, Medium 0, Large +2px) so portaled drawers follow too. */
  font-size: calc(14px + var(--kds-font-delta, 0px));
  transition: font-size 0.3s ease;
}

/* ===== Slots ===== */
.kds-slots-container {
  display: flex;
  align-items: center;
  gap: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 4px 0px;
}

.kds-slots-container::-webkit-scrollbar {
  display: none;
}

.kds-slot-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 4px;
  border: 1px solid var(--blue-b0, #0860e6);
  cursor: pointer;
  color: var(--blue-b0, #0860e6);
  white-space: nowrap;
  transition: 0.2s;
}

.kds-slot-item:hover {
  background-color: rgba(8, 96, 230, 0.08);
}

.kds-selected-slot {
  background-color: var(--blue-b0, #0860e6);
  color: white;
}

.kds-slot-time {
  font-size: calc(0.875rem + var(--kds-font-delta, 0px));
  font-weight: 600;
}

.kds-slot-count {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: var(--blue-b0, #0860e6);
  color: white;
  font-size: calc(0.75rem + var(--kds-font-delta, 0px));
  font-weight: 500;
  padding: 4px;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #c1c1c1;
}

.kds-slot-count-selected {
  background-color: white;
  color: var(--blue-b0, #0860e6);
  border: 1px solid var(--blue-b0, #0860e6);
}

.kds-slot-close-icon {
  width: 16px;
  height: 16px;
  color: white;
  cursor: pointer;
  flex-shrink: 0;
}

.kds-no-slot-container {
  display: flex;
  align-items: center;
  gap: 6px;
}

.kds-no-slot {
  font-size: calc(0.875rem + var(--kds-font-delta, 0px));
  font-weight: 600;
  color: #999;
}

.kds-slot-loading {
  font-size: calc(0.875rem + var(--kds-font-delta, 0px));
  color: #666;
  padding: 4px 0;
}

/* ===== Main Layout ===== */
.kds-main-layout {
  display: flex;
  justify-content: space-between;
  flex: 1;
  min-height: 0;
  overflow: visible;
  padding: 8px 0;
  gap: 16px;
}

.kds-orders-container {
  display: flex;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  zoom: 1;
  flex: 1;
  min-width: 0;
}

/* ===== Scrollable Container (horizontal scroll working) ===== */
.kds-main-order-container {
  padding: 12px;
  height: calc(100vh - 140px);
  overflow-x: hidden;
  overflow-y: auto;
  white-space: normal;
  box-sizing: border-box;
  display: block; /* Removed grid for JS masonry */

  width: 100%;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

.kds-main-order-container .horizontal-loader,
.kds-main-order-container .no-orders-text {
  grid-column: 1 / -1;
  width: 100%;
}

@media (max-width: 900px) {
  .kds-section-header,
  .kds-section-right-group {
    flex-wrap: wrap;
    gap: 8px;
  }
}

/* ===== Scrollbar Styling ===== */
.kds-main-order-container::-webkit-scrollbar {
  width: 10px;
}
.kds-main-order-container::-webkit-scrollbar-thumb {
  background-color: #d0d0d0;
  border-radius: 10px;
}
.kds-main-order-container::-webkit-scrollbar-track {
  background: #f5f5f5;
}
.kds-main-order-container {
  scrollbar-width: thin;
  scrollbar-color: #d0d0d0 #f5f5f5;
}

/* .kds-main-order-container {
  overscroll-behavior-x: contain;
  overscroll-behavior-y: auto;
} */

/* .kds-screen-layout {
  overscroll-behavior: contain;
  overscroll-behavior-x: contain;
} */

.kds-screen-layout {
  overscroll-behavior: contain;
}

/* ===== Section Header ===== */
.kds-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px; /* gap-3 is 12px */
  border-bottom: 1px solid #e2e8f0; /* border-b border-slate-200 */
  background: #ffffff;
  padding: 12px 16px; /* px-4 py-3 is 16px 12px */
  margin: 0;
}

.kds-section-left {
  display: flex;
  align-items: center;
  gap: 8px; /* gap-2 is 8px */
}

.kds-section-dot {
  height: 10px; /* h-2.5 is 10px */
  width: 10px; /* w-2.5 is 10px */
  border-radius: 50%; /* rounded-full */
  background-color: #334155; /* bg-slate-700 */
}

.kds-section-header h2 {
  font-size: calc(14px + var(--kds-font-delta, 0px)); /* text-sm is 14px */
  font-weight: 700; /* font-bold */
  text-transform: uppercase; /* uppercase */
  letter-spacing: 0.05em; /* tracking-wider */
  color: #1e293b; /* text-slate-800 */
  margin: 0;
  line-height: normal;
}

.count-badge {
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  border-radius: 50px;
  padding: 2px 10px;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  font-weight: 600;
  border: 1px solid #e2e8f0;
  background-color: #f1f5f9;
  color: #334155;
  width: auto;
  height: auto;
  gap: 0;
  line-height: normal;
}

.kds-section-right-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.kds-date-container {
  position: relative;
  display: inline-flex;
  align-items: center;
}

/* Reused OdsDateFilter, sized to sit level with the 36px settings button */
.kds-date-container .ods-date-filter-pill {
  height: 36px;
  padding: 0 12px;
  border-radius: 50px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.kds-date-container .ods-date-filter-pill:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.kds-date-container .ods-date-filter-text {
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #475569;
  letter-spacing: normal;
}

/* Header sits at the right edge — open the 280px calendar right-aligned so it stays on screen */
.kds-date-container .ods-date-dropdown {
  left: auto;
  right: 0;
}

.kds-settings-icon {
  width: 16px; /* h-4 */
  height: 16px; /* w-4 */
}

/* ===== Order Card ===== */
.kds-order-card {
  display: flex;
  flex-direction: column;
  width: 100% !important;
  background-color: #ffffff !important;
  break-inside: avoid;
  margin: 0 !important;
  padding: 16px !important;
  box-sizing: border-box;

  border-radius: 16px !important; /* rounded-2xl */
  border: 1px solid #e2e8f0 !important; /* border-slate-200 */
  box-shadow: 0 8px 26px rgba(15, 23, 42, 0.07) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.kds-order-card:hover {
  transform: translateY(-2px) !important; /* hover:-translate-y-0.5 */
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.1) !important; /* hover:shadow */
}

/* ===== Order Header ===== */
.kds-order-card-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0px !important; /* reset gap, row margins handle it */
  align-self: stretch;
  margin-bottom: 12px !important;
}

/* Header row 1 */
.kds-ref-header-row-1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.kds-ref-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.kds-ref-order-no {
  font-size: calc(15px + var(--kds-font-delta, 0px)) !important;
  font-weight: 600 !important;
  color: #1e293b !important; /* text-slate-800 */
  margin: 0 !important;
}

.kds-ref-edit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: transparent;
  border: none;
  color: #64748b; /* text-slate-500 */
  cursor: pointer;
  transition: all 0.2s ease;
}

.kds-ref-edit-btn:hover {
  color: #0f172a; /* text-slate-900 */
  background-color: #f1f5f9;
}

.kds-ref-edit-icon {
  width: 16px;
  height: 16px;
}

.kds-ref-header-right {
  text-align: right;
}

.kds-ref-time-prep-group {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #64748b; /* text-slate-500 */
}

.kds-ref-prep-tag {
  font-weight: 600 !important;
  color: #c46b21 !important;
}

/* Header row 2 */
.kds-ref-header-row-2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin-top: 12px; /* mt-3 */
}

/* Customizing the existing PlatformBadge components to look premium */
.kds-ref-platform-left .platform-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #334155 !important; /* slate-700 */
}

.kds-ref-platform-left .platform-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.kds-ref-info-right {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  color: #64748b; /* text-slate-500 */
}

.kds-ref-kot-token {
  font-weight: 500;
  color: #334155; /* text-slate-700 */
}

.kds-ref-divider {
  color: #cbd5e1; /* text-slate-300 */
}

.kds-ref-sub-order-type {
  color: #64748b; /* text-slate-500 */
}

/* Header row 3 */
.kds-ref-header-row-3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin-top: 8px; /* mt-2 */
}

.kds-ref-customer-name {
  font-size: calc(13px + var(--kds-font-delta, 0px)) !important;
  color: #475569 !important; /* text-slate-600 */
  margin: 0 !important;
  font-weight: 400;
}

.kds-ref-table-info {
  font-size: calc(12px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #64748b;
  background-color: #f1f5f9;
  padding: 2px 8px;
  border-radius: 50px;
}

.chevron-icon {
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  padding: 0px 2px;
  margin-left: 8px;
}

.edit-icon {
  width: 16px;
  height: 16px;
  color: #252b37;
  cursor: pointer;
  transition: color 0.2s ease;
}

.edit-icon:hover {
  color: #007aff;
}

.prep-time {
  font-size: calc(13px + var(--kds-font-delta, 0px));
  font-weight: 700;
  color: #e04a00;
  white-space: nowrap;
}

.platform-container {
  display: flex;
  align-items: center;
  gap: 6px;
}

.order-info {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  color: #555;
}

.platform-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  border-radius: 4px;
  padding: 2px 0px;
}

.platform-icon {
  width: 14px;
  height: 14px;
  object-fit: contain;
}

.platform-generic-icon {
  width: 14px;
  height: 14px;
  color: #333;
}

.platform-batch-table-key {
  color: #717680;
  text-align: center;
  font-family: "Outfit", "Inter", sans-serif;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

/* ===== Order Body ===== */
.kds-order-body {
  border-top: 1px dashed #cbd5e1 !important; /* border-dashed divide-slate-200 */
  border-bottom: 1px dashed #cbd5e1 !important;
  margin-top: 12px !important;
  padding: 4px 0 !important;
  gap: 0px !important; /* reset gap because py-3/margin manages spacing */
}

.kds-order-body::-webkit-scrollbar {
  width: 6px;
}

.kds-order-body::-webkit-scrollbar-track {
  background: #f8fafc;
  border-radius: 3px;
}

.kds-order-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.kds-order-body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.item-block {
  padding: 12px 0 !important; /* py-3 */
}

/* Add dividing border between children inside the body (divide-y divide-dashed) */
.kds-order-body > div + div {
  border-top: 1px dashed #cbd5e1 !important;
}

.select-all-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px; /* gap-3 is 12px */
  padding: 12px 0 !important; /* py-3 is 12px padding */
}

.select-all-label {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 10px; /* gap-2.5 is 10px */
  font-size: calc(13px + var(--kds-font-delta, 0px)); /* text-[13px] */
  font-weight: 500; /* font-medium */
  color: #334155; /* text-slate-700 */
  cursor: pointer;
}

.select-all-count {
  font-size: calc(12px + var(--kds-font-delta, 0px)); /* text-[12px] */
  font-weight: 500; /* font-medium */
  color: #94a3b8; /* text-slate-400 */
}

.item-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
}

.item-checkbox {
  display: flex;
  align-items: center;
  gap: 9px;
  flex: 1 1 auto;
  min-width: 0;
  cursor: pointer;
}

/* Modern Checkbox Style */
.kds-order-body input[type="checkbox"],
.select-all-checkbox {
  appearance: none;
  -webkit-appearance: none;
  width: 16px !important;
  height: 16px !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 4px !important;
  outline: none;
  cursor: pointer;
  display: inline-grid;
  place-content: center;
  background-color: #ffffff !important;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  margin-top: 2px !important;
  flex-shrink: 0;
}

.kds-order-body input[type="checkbox"]:checked,
.select-all-checkbox:checked {
  background-color: #2a71ff !important;
  border-color: #2a71ff !important;
}

.kds-order-body input[type="checkbox"]:checked::before,
.select-all-checkbox:checked::before {
  content: "";
  width: 8px;
  height: 5px;
  border-left: 2px solid white;
  border-bottom: 2px solid white;
  transform: rotate(-45deg) translate(1px, -1px);
}

.kds-order-body input[type="checkbox"]:disabled {
  background-color: #f1f5f9 !important;
  border-color: #cbd5e1 !important;
  cursor: not-allowed;
}

.item-name {
  font-size: calc(13px + var(--kds-font-delta, 0px)) !important;
  font-weight: 500 !important;
  color: #1e293b !important; /* text-slate-800 */
  line-height: 1.4;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}

.item-name.item-completed {
  text-decoration: line-through;
}

.item-qty {
  font-size: calc(13px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #64748b; /* text-slate-500 */
  margin-top: 0;
  flex: 0 0 auto;
}

/* ===== Item Separator (Dotted Line) ===== */
.item-separator {
  display: none !important; /* Separators are now handled dynamically by item borders */
}

/* ===== Notes & Add-ons ===== */
.kds-item-tags-inline {
  display: flex;
  gap: 6px;
  align-items: center;
  margin-left: 28px;
  margin-top: 6px;
  flex-wrap: wrap;
}

/* Note Pill: Amber style from reference */
.kds-note-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #fffbeb !important;
  color: #92400e !important;
  padding: 3px 8px !important;
  border-radius: 9999px !important;
  border: 1px solid #fef3c6 !important;
  box-shadow: none !important;
}

.kds-note-pill svg {
  flex-shrink: 0;
}

.kds-note-dot {
  width: 6px;
  height: 6px;
  background-color: #d97706 !important;
  border-radius: 50%;
  flex-shrink: 0;
}

.kds-note-text {
  font-size: calc(10px + var(--kds-font-delta, 0px)) !important;
  font-weight: 500 !important;
  color: #92400e !important;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}

/* Addon Pill: Slate style */
.kds-addon-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background-color: #f1f5f9 !important; /* slate-100 */
  color: #475569 !important; /* slate-600 */
  padding: 3px 8px !important;
  border-radius: 9999px !important;
  border: 1px solid #e2e8f0 !important; /* slate-200 */
  box-shadow: none !important;
}

.kds-addon-plus {
  color: #64748b !important;
  font-weight: 600 !important;
}

.kds-addon-text {
  font-size: calc(10px + var(--kds-font-delta, 0px)) !important;
  color: #475569 !important;
  font-weight: 500 !important;
  white-space: nowrap;
}

/* ===== Responsive ===== */

@media (max-width: 1020px) {
  .kds-order-card {
    width: 100% !important;
  }
}

@media (max-width: 520px) {
  .kds-item-tags-inline {
    margin-left: 22px;
    gap: 6px;
  }

  .kds-note-pill,
  .kds-addon-pill {
    padding: 5px 10px;
    font-size: calc(12px + var(--kds-font-delta, 0px));
  }
}

/* ===== Footer Buttons ===== */
.kds-order-footer {
  display: flex;
  margin-top: 16px !important; /* mt-4 */
  gap: 12px !important; /* gap-3 */
}

.start-btn,
.reprint-btn,
.ready-btn {
  display: inline-flex !important;
  height: 44px !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  border-radius: 50px !important;
  font-size: calc(13px + var(--kds-font-delta, 0px)) !important;
  font-weight: 500 !important;
  border: none !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  box-shadow: none !important;
}

/* Reprint KOT button: blue light background */
.reprint-btn {
  background-color: #e8f3ff !important;
  color: #2a71ff !important;
  flex: 1;
}

.reprint-btn:hover:not([disabled]) {
  background-color: #dcebff !important; /* hover:bg-[#dcebff] */
}

/* Complimentary blink: gentle pulsing border + shadow in Re-Print KOT blue */
.reprint-btn-complimentary:not([disabled]) {
  color: #2a71ff !important;
  border: 2px solid #b7d5ff !important;
  animation: reprint-blink 1.4s ease-in-out infinite !important;
}

.reprint-btn-complimentary:not([disabled]) .reprint-icon {
  color: #2a71ff !important;
}

@keyframes reprint-blink {
  0%,
  100% {
    background: linear-gradient(135deg, #e8f3ff, #ffffff, #ffffff);
    box-shadow: 0 4px 12px rgba(42, 113, 255, 0.12);
    border-color: #b7d5ff;
  }
  50% {
    background: linear-gradient(135deg, #c9e2ff, #e8f3ff, #ffffff);
    box-shadow: 0 4px 16px rgba(42, 113, 255, 0.32);
    border-color: #2a71ff;
  }
}

.ready-btn,
.start-btn {
  background-color: #7bcb89 !important;
  color: #ffffff !important;
  flex: 1;
}

.ready-btn:hover:not([disabled]),
.start-btn:hover:not([disabled]) {
  background-color: #6ab979 !important;
}

/* Disabled states: light slate from reference */
.reprint-btn[disabled],
.ready-btn[disabled],
.start-btn[disabled] {
  background-color: #f1f5f9 !important; /* bg-slate-100 */
  color: #94a3b8 !important; /* text-slate-400 */
  cursor: not-allowed !important;
  opacity: 1 !important;
}

/* Cart closed: reprint looks disabled but stays clickable to surface the snackbar */
.reprint-btn.reprint-btn-disabled,
.reprint-btn.reprint-btn-disabled:hover {
  background-color: #f1f5f9 !important; /* bg-slate-100 */
  color: #94a3b8 !important; /* text-slate-400 */
  cursor: not-allowed !important;
  border: none !important;
  animation: none !important;
}

.reprint-btn.reprint-btn-disabled .reprint-icon {
  color: #94a3b8 !important;
}

/* Icons within buttons */
.reprint-icon,
.ready-icon,
.chevron-icon {
  width: 16px !important;
  height: 16px !important;
  margin: 0 !important;
  color: inherit !important;
}

/* ===== Loader Spinner ===== */
.loader {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007aff;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  animation: spin 0.8s linear infinite;
  display: inline-block;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* ===== Item Loader ===== */
.item-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #007aff;
  gap: 6px;
  padding: 10px 0;
}
.item-loader p {
  font-size: calc(13px + var(--kds-font-delta, 0px));
  color: #555;
}

/* ===== Horizontal Loader ===== */
.horizontal-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 12px;
  height: 4px;
  width: 100%;
  position: relative;
}
.horizontal-loader-bar {
  width: 50px;
  height: 4px;
  background: #007aff;
  border-radius: 2px;
  animation: load-horizontal 1s linear infinite;
}

.kds-orders-container > .horizontal-loader {
  flex-shrink: 0;
  margin-top: 0;
}

@keyframes load-horizontal {
  0% {
    transform: translateX(0);
    opacity: 0.4;
  }
  50% {
    transform: translateX(100px);
    opacity: 1;
  }
  100% {
    transform: translateX(200px);
    opacity: 0.4;
  }
}

/* ===== Text States ===== */
.loading-text,
.no-orders-text {
  text-align: center;
  color: #888;
  margin: 10px;
  font-size: calc(14px + var(--kds-font-delta, 0px));
}

/* ===== Font Propagation ===== */
.kds-order-card,
.kds-order-body,
.kds-order-footer,
.kds-section-header,
.no-orders-text,
.order-info,
.item-name,
.item-qty,
.kds-note-pill,
.kds-addon-pill {
  font-size: 1em;
}

.removed-item {
  text-decoration: line-through;
  opacity: 0.6;
}

/* Combo pill styling */
.kds-combo-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  background-color: #0860e6;
  border-radius: 4px;
  margin-right: 6px;
  margin-bottom: 4px;
  flex-shrink: 0;
}

.kds-combo-text {
  font-size: calc(10px + var(--kds-font-delta, 0px));
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.02em;
}

/* Inline variant used in JobModal next to item name */
.kds-combo-pill-inline {
  margin-left: 6px;
  margin-bottom: 0;
  vertical-align: middle;
}

/* Complimentary pill styling */
.kds-complimentary-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background-color: #dbeafe;
  border: 1px solid #60a5fa;
  border-radius: 12px;
  margin-right: 6px;
  margin-bottom: 4px;
}

.kds-gift-icon {
  width: 14px;
  height: 14px;
  color: #2563eb;
  flex-shrink: 0;
}

.kds-complimentary-text {
  font-size: calc(0.75rem + var(--kds-font-delta, 0px));
  color: #1e40af;
  font-weight: 500;
  white-space: nowrap;
}

.customerNotes {
  background-color: #fff9f2 !important;
  color: #314158 !important;
  width: 100%;
  border: 1px solid #ffedd4 !important;
  border-radius: 16px;
  padding: 8px 10px;
  margin-top: 6px;
  font-size: calc(13px + var(--kds-font-delta, 0px));
  font-weight: 500;
  box-shadow: 0 1px 2px 0 rgba (0, 0, 0, 0.05);
}

.kdsCustomerNotesUpperWrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #f54900;
  font-weight: 700;
  font-size: calc(11px + var(--kds-font-delta, 0px));
  margin-bottom: 4px;
}

/* ═══ DARK THEME — KDS ═══ */
.dark .kds-orders-container {
  background-color: #1e293b;
  border-color: #334155;
}
.dark .kds-section-header {
  background: #1e293b;
  border-bottom-color: #334155;
}
.dark .kds-section-header h2 { color: #f1f5f9; }
.dark .kds-section-dot { background-color: #64748b; }
.dark .count-badge {
  background-color: #0f172a;
  border-color: #334155;
  color: #94a3b8;
}
.dark .kds-order-card {
  background-color: #1e293b !important;
  border-color: #334155 !important;
}
.dark .kds-order-card:hover {
  box-shadow: 0 14px 34px rgba(0,0,0,0.4) !important;
}
.dark .kds-ref-order-no { color: #f1f5f9 !important; }
.dark .kds-ref-time-prep-group { color: #94a3b8; }
.dark .kds-ref-customer-name { color: #94a3b8 !important; }
.dark .kds-ref-table-info { background-color: #0f172a; color: #64748b; }
.dark .kds-ref-info-right { color: #64748b; }
.dark .kds-ref-kot-token { color: #94a3b8; }
.dark .kds-ref-divider { color: #475569; }
.dark .kds-ref-sub-order-type { color: #64748b; }
.dark .kds-ref-platform-left .platform-badge { color: #94a3b8 !important; }
.dark .platform-generic-icon { color: #94a3b8; }
.dark .order-info { color: #64748b; }
.dark .platform-batch-table-key { color: #64748b; }
.dark .kds-order-body { border-top-color: #334155 !important; border-bottom-color: #334155 !important; }
.dark .kds-order-body > div + div { border-top-color: #334155 !important; }
.dark .kds-order-body::-webkit-scrollbar-track { background: #0f172a; }
.dark .kds-order-body::-webkit-scrollbar-thumb { background: #334155; }
.dark .kds-main-order-container::-webkit-scrollbar-thumb { background-color: #334155; }
.dark .kds-main-order-container::-webkit-scrollbar-track { background: #0f172a; }
.dark .kds-main-order-container { scrollbar-color: #334155 #0f172a; }
.dark .select-all-label { color: #94a3b8; }
.dark .kds-date-container .ods-date-filter-pill {
  border-color: #334155;
  background: #1e293b;
}
.dark .kds-date-container .ods-date-filter-pill:hover {
  border-color: #475569;
  background: #334155;
}
.dark .kds-date-container .ods-date-filter-text { color: #94a3b8; }
.dark .kds-no-slot { color: #64748b; }
.dark .kds-slot-loading { color: #475569; }

/* Orders view: Processing stays in one horizontal rail; Pending keeps its own rail. */
.kds-screen-layout.kds-orders-screen {
  height: calc(100dvh - 174px);
  min-height: 0;
}

.kds-main-layout.kds-orders-layout,
.kds-main-layout.kds-tables-layout {
  min-height: 0;
  overflow: hidden;
}

.kds-orders-rail-container {
  display: block;
  flex: 1;
  height: auto;
  min-height: 0;
  overflow-x: auto;
  overflow-y: hidden;
  overscroll-behavior-x: contain;
  -webkit-overflow-scrolling: touch;
}

.kds-processing-rail {
  display: flex;
  align-items: stretch;
  flex-flow: row nowrap;
  gap: 14px;
  width: max-content;
  min-width: 100%;
  height: 100%;
  padding: 2px 2px 12px;
  box-sizing: border-box;
}

.kds-processing-rail:focus-visible,
.kds-orders-rail-container:focus-visible {
  outline: 2px solid #ad5b20;
  outline-offset: -2px;
}

.kds-processing-rail > .kds-order-card {
  flex: 0 0 clamp(280px, 30vw, 360px);
  width: clamp(280px, 30vw, 360px) !important;
  min-width: 0;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.kds-processing-rail > .kds-order-card .kds-order-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior-y: contain;
}

.kds-processing-controls {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
}

.kds-processing-control {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #687582;
  font-size: calc(11px + var(--kds-font-delta, 0px));
  font-weight: 700;
  letter-spacing: .04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.kds-processing-control .MuiSelect-select {
  max-width: 160px;
  min-height: 34px;
  padding: 0 28px 0 9px !important;
  border: 1px solid #d8e0e5;
  border-radius: 8px;
  background: #f8faf9;
  color: #263640;
  font: inherit;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  letter-spacing: normal;
  text-transform: none;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.kds-processing-control .MuiSelect-select:focus-visible,
.kds-clear-filter:focus-visible,
.kds-no-filter-results button:focus-visible {
  outline: 2px solid #ad5b20;
  outline-offset: 2px;
}

.kds-clear-filter,
.kds-no-filter-results button {
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid #e3c9b7;
  border-radius: 7px;
  background: #fff8f2;
  color: #914c21;
  font: inherit;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  font-weight: 650;
  cursor: pointer;
}

.kds-results-count {
  color: #71808a;
  font-size: calc(11px + var(--kds-font-delta, 0px));
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.kds-no-filter-results {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex: 1;
  min-height: 150px;
  color: #697781;
}

.kds-no-filter-results p {
  margin: 0;
}

.dark .kds-processing-control { color: #b3c0c8; }
.dark .kds-processing-control .MuiSelect-select {
  border-color: #4b5963;
  background: #26343e;
  color: #edf2f4;
}
.kds-processing-menu-paper {
  max-height: 280px !important;
  border: 1px solid #d8e0e5;
  border-radius: 8px !important;
  background: #f8faf9 !important;
  color: #263640 !important;
}
.kds-processing-menu-paper .MuiMenuItem-root { min-height: 36px; font-size: calc(12px + var(--kds-font-delta, 0px)); }
.kds-processing-menu-paper .MuiMenuItem-root.Mui-selected,
.kds-processing-menu-paper .MuiMenuItem-root.Mui-selected:hover { background: #e8efeb; }
.dark .kds-processing-menu-paper {
  border-color: #4b5963;
  background: #26343e !important;
  color: #edf2f4 !important;
}
.dark .kds-processing-menu-paper .MuiMenuItem-root.Mui-selected,
.dark .kds-processing-menu-paper .MuiMenuItem-root.Mui-selected:hover { background: #3a4b43; }
.dark .kds-clear-filter,
.dark .kds-no-filter-results button {
  border-color: #694c3b;
  background: #382c26;
  color: #f1c5a4;
}
.dark .kds-results-count,
.dark .kds-no-filter-results { color: #a5b2ba; }

@media (max-width: 900px) {
  .kds-main-layout.kds-orders-layout {
    gap: 10px;
  }
  .kds-orders-layout .kds-section-left {
    flex-wrap: wrap;
  }
}

@media (max-width: 600px) {
  .kds-processing-controls {
    width: 100%;
  }
  .kds-processing-control .MuiSelect-select {
    max-width: 135px;
  }
}

.item-line .kds-item-preparation.is-inline {
  display: block;
  flex: 0 1 auto;
  min-width: 0;
  margin: 0;
  padding: 3px 5px;
  border-top: 0;
  border-right: 0;
  border-bottom: 0;
  border-radius: 0;
  background: transparent;
  white-space: nowrap;
}

.item-line .kds-item-preparation.is-inline .kds-prep-summary {
  flex-wrap: nowrap;
  gap: 5px;
}

.item-line .kds-item-preparation.is-inline .kds-prep-estimate,
.item-line .kds-item-preparation.is-inline .kds-prep-countdown {
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  line-height: 1.05;
}

.kds-item-preparation.is-inline .kds-prep-estimate > span,
.kds-item-preparation.is-inline .kds-prep-countdown > span {
  font-size: calc(9px + var(--kds-font-delta, 0px));
  line-height: 1.05;
}

.kds-item-preparation.is-inline .kds-prep-estimate strong,
.kds-item-preparation.is-inline .kds-prep-countdown strong {
  font-size: calc(11px + var(--kds-font-delta, 0px));
  line-height: 1.05;
}

.order-item-preview-row {
  align-items: center;
}

.order-item-preview-row .order-item-preview-name {
  flex: 1 1 auto;
}

.order-item-preview-row .kds-item-preparation.is-inline {
  flex: 0 0 auto;
  margin: 0;
  padding: 2px 4px;
}

.order-item-preview-row .kds-prep-summary { flex-wrap: nowrap; gap: 4px; }
@media (max-width: 600px) {
  .item-line { gap: 5px; }
  .item-line .kds-item-preparation.is-inline .kds-prep-summary { gap: 4px; }
}

/* Rush mode keeps the same one-row rail while tightening each ticket's rhythm. */
.kds-rush-mode .kds-processing-rail {
  gap: 9px;
}

.kds-rush-mode .kds-processing-rail > .kds-order-card {
  flex-basis: 200px;
  width: 200px !important;
  padding: 11px !important;
  border-radius: 12px !important;
}

.kds-rush-mode .kds-order-card-header {
  margin-bottom: 7px !important;
}

.kds-rush-mode .kds-ref-header-row-2 {
  margin-top: 7px;
}

.kds-rush-mode .kds-ref-header-row-3 {
  margin-top: 5px;
}

.kds-rush-mode .kds-order-body {
  margin-top: 7px !important;
  padding: 1px 0 !important;
}

.kds-rush-mode .item-block {
  padding: 6px 0 !important;
}

.kds-rush-mode .kds-item-tags-inline {
  margin-top: 3px;
  margin-left: 23px;
  gap: 4px;
}

.kds-rush-mode .kds-note-pill,
.kds-rush-mode .kds-addon-pill {
  padding: 2px 6px !important;
}

.kds-rush-mode .kds-order-footer {
  margin-top: 8px !important;
  gap: 7px !important;
}

.kds-rush-mode .kds-order-footer .start-btn,
.kds-rush-mode .kds-order-footer .reprint-btn {
  height: 36px !important;
}

.kds-item-ready-button {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 28px;
  padding: 0 8px;
  border: 1px solid #b6d8c2;
  border-radius: 7px;
  background: #edf7ef;
  color: #28643e;
  font: inherit;
  font-size: calc(11px + var(--kds-font-delta, 0px));
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}

.kds-item-ready-button svg {
  width: 13px;
  height: 13px;
}

.kds-item-ready-button:hover:not(:disabled) {
  background: #deefdf;
  border-color: #7eae8c;
}

.kds-item-ready-button:focus-visible {
  outline: 2px solid #38784b;
  outline-offset: 2px;
}

.kds-item-ready-button:disabled {
  cursor: not-allowed;
}

.kds-item-ready-button.is-confirmed {
  background: #e7f2e9;
  border-color: #c7dec9;
  color: #3e6948;
  opacity: 0.82;
}

.kds-rush-item-label {
  border: 0;
  border-radius: 6px;
  padding: 5px 3px;
  min-height: 40px;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.kds-rush-item-label:hover:not(:disabled) {
  background: rgba(56, 120, 75, .1);
}

.kds-rush-item-label:focus-visible {
  outline: 2px solid #38784b;
  outline-offset: 2px;
}

.kds-rush-item-label:disabled {
  cursor: default;
}

/* SlotList is portaled into the OrdersPage header when the host target exists. */
#kds-slots-header-mount {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
}

.kds-header-slots-container {
  width: 100%;
  min-width: 0;
  padding: 0;
  overflow-x: auto;
  overflow-y: visible;
  scrollbar-width: thin;
}

.kds-header-slots-container .board-slots-container {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 8px;
  width: max-content;
}

.kds-header-slots-container .slotItem {
  flex: 0 0 auto;
  white-space: nowrap;
}

/* Rush: five-column, sequential ticket board + consolidated prep ledger. */
.kds-rush-mode.kds-main-order-container {
  overflow: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
}

.rush-prep-summary {
  display: flex;
  flex: 0 0 184px;
  flex-direction: column;
  min-width: 0;
  max-height: 100%;
  overflow: hidden;
  border: 1px solid #d9dfd8;
  border-radius: 12px;
  background: #f5f6f0;
  color: #26322c;
  box-shadow: 0 4px 14px rgba(36, 51, 40, .08);
}

.rush-summary-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 17px 15px 13px;
  border-bottom: 1px solid #dfe5de;
}

.rush-summary-eyebrow {
  color: #748278;
  font-size: calc(10px + var(--kds-font-delta, 0px));
  font-weight: 750;
  letter-spacing: .12em;
  text-transform: uppercase;
}

.rush-summary-header h2 {
  margin: 4px 0 0;
  color: #29382f;
  font-size: calc(17px + var(--kds-font-delta, 0px));
  letter-spacing: -.02em;
}

.rush-summary-total {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  border: 1px solid #ced9cc;
  border-radius: 11px;
  background: #eaf1e7;
  color: #405942;
  font-size: calc(18px + var(--kds-font-delta, 0px));
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.rush-summary-accept {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 13px;
  border-bottom: 1px solid #dfe5de;
}

.rush-summary-accept > div {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.rush-summary-accept strong { color: #344238; font-size: calc(12px + var(--kds-font-delta, 0px)); }
.rush-summary-accept span { color: #78857b; font-size: calc(10px + var(--kds-font-delta, 0px)); }

.rush-summary-accept button,
.rush-summary-state button,
.rush-inline-error button,
.rush-board-state button {
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid #bfd0bc;
  border-radius: 7px;
  background: #e7f0e4;
  color: #38513b;
  font: inherit;
  font-size: calc(11px + var(--kds-font-delta, 0px));
  font-weight: 750;
  cursor: pointer;
}

.rush-summary-accept button:hover:not(:disabled),
.rush-summary-state button:hover,
.rush-inline-error button:hover,
.rush-board-state button:hover { background: #dbe9d8; }

.rush-summary-accept button:disabled { opacity: .46; cursor: not-allowed; }

.rush-summary-list {
  min-height: 0;
  overflow-y: auto;
  padding: 4px 13px 14px;
}

.rush-summary-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: baseline;
  gap: 5px 8px;
  padding: 11px 2px 10px;
  border-bottom: 1px solid #dfe5de;
}

.rush-summary-dish {
  overflow: hidden;
  color: #344238;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rush-summary-qty {
  grid-row: span 2;
  align-self: center;
  color: #9a6b1e;
  font-size: calc(18px + var(--kds-font-delta, 0px));
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.rush-summary-breakdown {
  color: #7b887e;
  font-size: calc(10px + var(--kds-font-delta, 0px));
}

.rush-summary-state,
.rush-summary-empty {
  display: grid;
  gap: 8px;
  padding: 20px 14px;
  color: #6c7a70;
  font-size: calc(12px + var(--kds-font-delta, 0px));
}

.rush-summary-empty strong { color: #344238; }
.rush-summary-empty span { line-height: 1.4; }
.rush-summary-refresh { margin: 8px 14px; color: #718075; font-size: calc(10px + var(--kds-font-delta, 0px)); }

.rush-summary-skeleton {
  display: grid;
  gap: 12px;
  padding: 16px 14px;
}

.rush-summary-skeleton > div {
  height: 35px;
  border-radius: 6px;
  background: linear-gradient(90deg, #e5eae2, #d8e1d7, #e5eae2);
  background-size: 200% 100%;
  animation: rush-skeleton 1.8s ease-in-out infinite;
}

.rush-board-wrap { display: flex; flex-direction: column; min-width: 0; min-height: 100%; }
.rush-board-scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  overscroll-behavior-x: contain;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
}

.rush-board {
  display: grid;
  grid-template-columns: repeat(5, minmax(300px, 1fr));
  align-items: start;
  gap: 11px;
  min-width: 0;
  padding: 2px 2px 14px;
}

.rush-column {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 11px;
  min-width: 0;
}

.rush-ticket {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 12px !important;
  overflow: visible;
  border: 1px solid #d9e0d8 !important;
  border-radius: 10px !important;
  background: #fffefa !important;
  box-shadow: 0 3px 10px rgba(30, 44, 34, .07) !important;
}

.rush-ticket-header { display: grid; gap: 7px; }
.rush-ticket-title { display: flex; align-items: center; flex-wrap: wrap; min-width: 0; gap: 7px; }
.rush-ticket-number {
  display: grid;
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  place-items: center;
  border-radius: 7px;
  background: #e2b96f;
  color: #2d281c;
  font-size: calc(15px + var(--kds-font-delta, 0px));
  font-weight: 900;
  font-variant-numeric: tabular-nums;
}

.rush-order-type {
  min-width: 0;
  color: #29382f;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-weight: 750;
  overflow-wrap: anywhere;
}

.rush-edit-button {
  display: grid;
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  margin-left: auto;
  place-items: center;
  border: 1px solid #d8e0d7;
  border-radius: 7px;
  background: transparent;
  color: #66756a;
  cursor: pointer;
}

.rush-edit-button svg { width: 15px; height: 15px; fill: none; stroke: currentColor; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }
.rush-edit-button:hover { background: #edf2eb; color: #26372d; }
.rush-edit-button:focus-visible,
.rush-dish-action:focus-visible,
.rush-pagination button:focus-visible { outline: 2px solid #e2b96f; outline-offset: 2px; }

.rush-ticket-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px 8px;
  color: #718075;
  font-size: calc(10px + var(--kds-font-delta, 0px));
}

.rush-table-reference {
  display: inline-flex;
  min-width: 0;
  padding: 3px 7px;
  border: 1px solid #e0c88f;
  border-radius: 6px;
  background: #fbf3df;
  color: #6b5122;
  font-size: calc(10px + var(--kds-font-delta, 0px));
  font-weight: 750;
  line-height: 1.25;
  overflow-wrap: anywhere;
}
.rush-ticket .kds-order-timing { margin-top: 0; padding: 4px 6px; gap: 4px; border-radius: 6px; }
.rush-ticket .kds-order-timing__label { font-size: calc(9px + var(--kds-font-delta, 0px)); }
.rush-ticket .kds-order-timing__value { font-size: calc(16px + var(--kds-font-delta, 0px)); }
.rush-ticket .kds-order-timing__prep { font-size: calc(8px + var(--kds-font-delta, 0px)); }
.rush-ticket.kds-timing--green { border-left: 3px solid #38825d !important; }
.rush-ticket.kds-timing--orange { border-left: 3px solid #c57a20 !important; }
.rush-ticket.kds-timing--red { border-left: 3px solid #b02f34 !important; }
.rush-ticket-dishes { margin-top: 5px; border-top: 1px dashed #d9e0d8; }

.rush-dish { padding: 2px 0; border-bottom: 1px dashed #e0e5df; }
.rush-dish-action {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  min-height: 39px;
  gap: 8px;
  padding: 4px 5px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #2d3b32;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.rush-dish-action:hover:not(:disabled) { background: rgba(56, 91, 60, .07); }
.rush-dish-action:disabled { cursor: default; }
.rush-dish-name { flex: 1 1 auto; min-width: 0; line-height: 1.35; white-space: normal; overflow-wrap: anywhere; font-size: calc(12px + var(--kds-font-delta, 0px)); font-weight: 650; }
.rush-dish-qty { flex: 0 0 auto; color: #67756b; font-size: calc(11px + var(--kds-font-delta, 0px)); font-weight: 700; }
.rush-dish-state { flex: 0 0 auto; color: #637568; font-size: calc(9px + var(--kds-font-delta, 0px)); font-weight: 750; text-transform: uppercase; letter-spacing: .04em; }
.rush-dish.is-ready .rush-dish-name { color: #7c917f; text-decoration: line-through; text-decoration-thickness: 1px; }
.rush-dish.is-ready .rush-dish-state { color: #477b4c; }
.rush-dish.is-terminal .rush-dish-name { color: #89948b; text-decoration: line-through; }
.rush-dish-details { display: flex; flex-wrap: wrap; gap: 4px; padding: 3px 4px 1px; }
.rush-detail-pill {
  max-width: 100%;
  box-sizing: border-box;
  white-space: normal;
  padding: 3px 6px;
  border: 1px solid #dce3db;
  border-radius: 5px;
  color: #68766b;
  font-size: calc(9px + var(--kds-font-delta, 0px));
  line-height: 1.35;
  overflow-wrap: anywhere;
}
.rush-detail-pill.rush-note { border-color: #e3d6b7; color: #87652e; }

/* Pinned to the bottom of the rush board: pushed down when tickets are few, sticky when they overflow. */
.rush-pagination {
  position: sticky;
  bottom: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: auto;
  padding: 9px 3px 4px;
  border-top: 1px solid #e0e5df;
  background: #fff;
  color: #6f7c72;
  font-size: calc(11px + var(--kds-font-delta, 0px));
}

.rush-pagination > div { display: flex; align-items: center; gap: 9px; }
.rush-pagination button {
  min-height: 32px;
  padding: 0 12px;
  border: 1px solid #d4ddd3;
  border-radius: 7px;
  background: #f0f4ed;
  color: #344238;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}
.rush-pagination button:disabled { opacity: .4; cursor: not-allowed; }
.rush-page-indicator { color: #526156; font-variant-numeric: tabular-nums; white-space: nowrap; }

.rush-board-state {
  display: grid;
  align-content: center;
  justify-items: center;
  gap: 9px;
  min-height: 240px;
  color: #718075;
  text-align: center;
}
.rush-board-state strong { color: #344238; font-size: calc(18px + var(--kds-font-delta, 0px)); }
.rush-board-state span { font-size: calc(12px + var(--kds-font-delta, 0px)); }
.rush-inline-error { display: flex; align-items: center; justify-content: space-between; padding: 6px 8px; color: #87652e; font-size: calc(11px + var(--kds-font-delta, 0px)); }
.rush-board-loading { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: 11px; min-width: 0; }
.rush-skeleton-column { display: grid; align-content: start; gap: 11px; }
.rush-skeleton-ticket { height: 160px; border: 1px solid #d9e0d8; border-radius: 10px; background: linear-gradient(90deg, #f0f2ed, #e2e9e0, #f0f2ed); background-size: 200% 100%; animation: rush-skeleton 1.8s ease-in-out infinite; }
@keyframes rush-skeleton { 0%, 100% { opacity: .62; } 50% { opacity: 1; } }

.dark .rush-prep-summary,
.dark .rush-ticket { color: #ecf2ee; }
.dark .rush-prep-summary { border-color: #36433f; background: #202a28; box-shadow: 0 8px 22px rgba(10, 20, 17, .22); }
.dark .rush-summary-header,
.dark .rush-summary-accept { border-color: #374541; }
.dark .rush-summary-eyebrow { color: #a8b9af; }
.dark .rush-summary-header h2 { color: #f1f4ef; }
.dark .rush-summary-total { border-color: #607466; background: #2b3932; color: #d9ebd9; }
.dark .rush-summary-accept strong { color: #e8eee9; }
.dark .rush-summary-accept span { color: #9eafa5; }
.dark .rush-summary-accept button,
.dark .rush-summary-state button,
.dark .rush-inline-error button,
.dark .rush-board-state button { border-color: #77947d; background: #34483a; color: #e8f2e8; }
.dark .rush-summary-accept button:hover:not(:disabled),
.dark .rush-summary-state button:hover,
.dark .rush-inline-error button:hover,
.dark .rush-board-state button:hover { background: #405a46; }
.dark .rush-summary-row { border-color: #34413d; }
.dark .rush-summary-dish { color: #e4ebe5; }
.dark .rush-summary-qty { color: #f3d392; }
.dark .rush-summary-breakdown { color: #9cac9f; }
.dark .rush-summary-state,
.dark .rush-summary-empty { color: #aab7ad; }
.dark .rush-summary-empty strong { color: #dfe8e0; }
.dark .rush-summary-refresh { color: #a6b4aa; }
.dark .rush-summary-skeleton > div { background: linear-gradient(90deg, #2b3834, #35433e, #2b3834); background-size: 200% 100%; }
.dark .rush-ticket { border-color: #435049 !important; background: #252f2c !important; box-shadow: 0 3px 10px rgba(5, 13, 10, .18) !important; }
.dark .rush-order-type { color: #f0f2ec; }
.dark .rush-edit-button { border-color: #4c5b53; color: #bac8bd; }
.dark .rush-edit-button:hover { background: #34423b; color: #fff; }
.dark .rush-ticket-meta { color: #aebbb1; }
.dark .rush-table-reference {
  border-color: #74613c;
  background: #403824;
  color: #f0d89f;
}
.dark .rush-ticket-dishes { border-color: #46554c; }
.dark .rush-dish { border-color: #3d4a43; }
.dark .rush-dish-action { color: #eff3ed; }
.dark .rush-dish-action:hover:not(:disabled) { background: rgba(206, 224, 204, .08); }
.dark .rush-dish-qty { color: #c0ccc2; }
.dark .rush-dish-state { color: #a5b5a8; }
.dark .rush-dish.is-ready .rush-dish-name { color: #91a796; }
.dark .rush-dish.is-ready .rush-dish-state { color: #a6d2a9; }
.dark .rush-dish.is-terminal .rush-dish-name { color: #87948b; }
.dark .rush-detail-pill { border-color: #49574f; color: #b8c5ba; }
.dark .rush-detail-pill.rush-note { border-color: #766347; color: #e0c799; }
.dark .rush-pagination { border-color: #374541; background: #1b2422; color: #aab6ad; }
.dark .rush-pagination button { border-color: #526258; background: #2b3731; color: #e4ebe5; }
.dark .rush-page-indicator { color: #c7d0c8; }
.dark .rush-board-state { color: #acb9af; }
.dark .rush-board-state strong { color: #e8eee8; }
.dark .rush-inline-error { color: #e2c28f; }
.dark .rush-skeleton-ticket { border-color: #394841; background: linear-gradient(90deg, #242e2a, #303c36, #242e2a); background-size: 200% 100%; }

@media (max-width: 1050px) {
  .rush-prep-summary { flex-basis: 184px; }
}

@media (max-width: 700px) {
  .kds-main-layout.kds-orders-layout:has(.rush-prep-summary),
  .kds-main-layout.kds-tables-layout { flex-direction: column; overflow: hidden; }
  .rush-prep-summary { flex: 0 0 auto; max-height: 180px; width: 100%; }
  .rush-summary-header { padding: 9px 12px; }
  .rush-summary-header h2 { font-size: calc(15px + var(--kds-font-delta, 0px)); }
  .rush-summary-accept { padding: 8px 12px; }
  .rush-summary-list { display: flex; gap: 12px; overflow-x: auto; overflow-y: hidden; padding: 0 12px 8px; }
  .rush-summary-row { flex: 0 0 140px; border-bottom: 0; }
  .rush-board { grid-template-columns: repeat(2, minmax(300px, 1fr)); min-width: max-content; width: 100%; }
  .rush-board-loading { grid-template-columns: repeat(2, minmax(205px, 1fr)); min-width: max-content; }
  .rush-pagination { align-items: flex-start; flex-direction: column; }
  .rush-pagination > div { width: 100%; justify-content: space-between; }
}

@media (max-width: 700px) {
  .kds-main-layout.kds-orders-layout {
    flex-direction: row;
    overflow: hidden;
    gap: 8px;
  }
  .kds-main-layout.kds-orders-layout .left-bar-kds {
    flex: 0 0 min(38vw, 280px);
    width: min(38vw, 280px);
    min-height: 0;
  }
  .kds-main-layout.kds-orders-layout .kds-orders-container {
    flex: 1 1 0;
    width: auto;
    min-width: 0;
  }
  .kds-main-layout.kds-orders-layout .left-bar-kds.is-collapsed {
    flex: 0 0 58px;
    width: 58px;
  }
}

/* Pending disclosure gives the Processing column all remaining width. */
.kds-main-layout.kds-orders-layout {
  justify-content: flex-start;
  min-width: 0;
}

.kds-main-layout.kds-orders-layout > .left-bar-kds.is-collapsed {
  flex-basis: 66px;
}

.kds-main-layout.kds-orders-layout > .kds-orders-container {
  flex: 1 1 0;
  min-width: 0;
}

@media (max-width: 700px) {
  .kds-main-layout.kds-orders-layout > .left-bar-kds {
    flex: 0 0 min(38vw, 280px);
    width: min(38vw, 280px);
  }

  .kds-main-layout.kds-orders-layout > .left-bar-kds.is-collapsed {
    flex-basis: 58px;
    width: 58px;
  }

  .kds-main-layout.kds-orders-layout > .kds-orders-container {
    flex: 1 1 0;
    width: auto;
    min-width: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .kds-main-layout.kds-orders-layout > .left-bar-kds {
    transition: none;
  }
}

/* Rush queue interactions: dish and whole-ticket completion controls. */
.rush-ticket-header {
  position: relative;
  min-width: 0;
}

.rush-ticket-complete {
  display: block;
  width: 100%;
  min-width: 0;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.rush-ticket-complete:disabled { cursor: default; }
.rush-ticket-complete:not(:disabled):hover .rush-ticket-title { color: #41694b; }
.rush-ticket-complete:focus-visible,
.rush-edit-button:focus-visible,
.rush-dish-action:focus-visible,
.rush-summary-selectable:focus-visible {
  outline: 3px solid #bd8738;
  outline-offset: 3px;
}

.rush-ticket-header-content { display: grid; gap: 7px; }
.rush-ticket-header-content > .rush-ticket-title { padding-right: 36px; }
.rush-ticket-countdown { display: block; }
.rush-ticket-busy {
  justify-self: start;
  color: #815f2b;
  font-size: calc(10px + var(--kds-font-delta, 0px));
  font-weight: 750;
}
.rush-edit-button {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  margin: 0;
}

.rush-ticket.is-highlighted {
  outline: 3px solid #b9822f;
  outline-offset: 2px;
}
.rush-highlight-badge {
  justify-self: start;
  padding: 3px 7px;
  border: 1px solid #d2a24f;
  border-radius: 999px;
  background: #fbf0d4;
  color: #63491e;
  font-size: calc(9px + var(--kds-font-delta, 0px));
  font-weight: 800;
  letter-spacing: .04em;
  text-transform: uppercase;
}
.rush-highlight-empty {
  margin: 2px 2px 9px;
  padding: 9px 11px;
  border: 1px solid #e0c88f;
  border-radius: 8px;
  background: #fbf3df;
  color: #6b5122;
  font-size: calc(11px + var(--kds-font-delta, 0px));
  line-height: 1.4;
}

.rush-summary-selectable {
  width: 100%;
  border: 0;
  border-bottom: 1px solid #dfe5de;
  border-radius: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.rush-summary-selectable:hover,
.rush-summary-selectable.is-selected {
  background: #f4f0e4;
}
.rush-summary-selectable.is-selected {
  box-shadow: inset 3px 0 #b9822f;
}

.dark .rush-ticket-complete:not(:disabled):hover .rush-ticket-title { color: #d6e7cc; }
.dark .rush-ticket-busy { color: #e0c799; }
.dark .rush-ticket.is-highlighted { outline-color: #d9ad59; }
.dark .rush-highlight-badge {
  border-color: #8b7040;
  background: #403824;
  color: #f0d89f;
}
.dark .rush-highlight-empty {
  border-color: #766347;
  background: #403824;
  color: #e0c799;
}
.dark .rush-summary-selectable:hover,
.dark .rush-summary-selectable.is-selected { background: #2e3a33; }
.dark .rush-summary-selectable.is-selected { box-shadow: inset 3px 0 #d9ad59; }
.dark .rush-summary-selectable { border-bottom-color: #34413d; }

@media (max-width: 520px) {
  .rush-ticket { padding: 10px !important; }
  .rush-ticket-header-content > .rush-ticket-title { padding-right: 34px; }
  .rush-ticket-meta { gap: 4px 6px; }
}

/* Inline spinner inside buttons waiting on an API call */
.loader.kds-btn-loader {
  width: 12px;
  height: 12px;
  margin-right: 6px;
  vertical-align: -2px;
  flex: 0 0 auto;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/KDS/kds.css"],"names":[],"mappings":"AAAA;;mCAEmC;;AAEnC,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;;EAEtB;0FACwF;EACxF,kDAAkD;EAClD,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yCAAyC;EACzC,YAAY;EACZ,qDAAqD;EACrD,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sDAAsD;EACtD,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sDAAsD;EACtD,WAAW;EACX,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,OAAO;EACP,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,2CAA2C;EAC3C,OAAO;EACP,OAAO;EACP,YAAY;AACd;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc,EAAE,gCAAgC;;EAEhD,WAAW;EACX,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;;IAEE,eAAe;IACf,QAAQ;EACV;AACF;;AAEA,kCAAkC;AAClC;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;;;GAGG;;AAEH;;;GAGG;;AAEH;EACE,4BAA4B;AAC9B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS,EAAE,kBAAkB;EAC7B,gCAAgC,EAAE,8BAA8B;EAChE,mBAAmB;EACnB,kBAAkB,EAAE,2BAA2B;EAC/C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,iBAAiB;AAC7B;;AAEA;EACE,YAAY,EAAE,kBAAkB;EAChC,WAAW,EAAE,kBAAkB;EAC/B,kBAAkB,EAAE,iBAAiB;EACrC,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,kDAAkD,EAAE,oBAAoB;EACxE,gBAAgB,EAAE,cAAc;EAChC,yBAAyB,EAAE,cAAc;EACzC,sBAAsB,EAAE,mBAAmB;EAC3C,cAAc,EAAE,mBAAmB;EACnC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kDAAkD;EAClD,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,gGAAgG;AAChG;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW,EAAE,QAAQ;EACrB,YAAY,EAAE,QAAQ;AACxB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,sBAAsB;;EAEtB,8BAA8B,EAAE,gBAAgB;EAChD,oCAAoC,EAAE,qBAAqB;EAC3D,wDAAwD;EACxD,4DAA4D;AAC9D;;AAEA;EACE,sCAAsC,EAAE,2BAA2B;EACnE,wDAAwD,EAAE,iBAAiB;AAC7E;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAE,qCAAqC;EAC1D,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,yBAAyB,EAAE,mBAAmB;EAC9C,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc,EAAE,mBAAmB;EACnC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc,EAAE,mBAAmB;EACnC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kDAAkD;EAClD,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,gBAAgB,EAAE,SAAS;AAC7B;;AAEA,sEAAsE;AACtE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kDAAkD;EAClD,gBAAgB;EAChB,yBAAyB,EAAE,cAAc;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kDAAkD;EAClD,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,cAAc,EAAE,mBAAmB;AACrC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,eAAe,EAAE,SAAS;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB,EAAE,mBAAmB;EAC9C,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kDAAkD;EAClD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,kDAAkD;EAClD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,yCAAyC,EAAE,mCAAmC;EAC9E,4CAA4C;EAC5C,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB,EAAE,kDAAkD;AACzE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B,EAAE,SAAS;AACvC;;AAEA,kFAAkF;AAClF;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS,EAAE,kBAAkB;EAC7B,0BAA0B,EAAE,yBAAyB;AACvD;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,SAAS,EAAE,oBAAoB;EAC/B,kDAAkD,EAAE,gBAAgB;EACpE,gBAAgB,EAAE,gBAAgB;EAClC,cAAc,EAAE,mBAAmB;EACnC,eAAe;AACjB;;AAEA;EACE,kDAAkD,EAAE,gBAAgB;EACpE,gBAAgB,EAAE,gBAAgB;EAClC,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;;EAEE,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;EAC7B,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,oCAAoC;EACpC,yBAAyB;EACzB,yCAAyC;EACzC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,WAAW;EACX,UAAU;EACV,WAAW;EACX,4BAA4B;EAC5B,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,yBAAyB,EAAE,mBAAmB;EAC9C,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;EACnC,aAAa;EACb,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,wBAAwB,EAAE,2DAA2D;AACvF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,gCAAgC;EAChC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC,EAAE,cAAc;EACpD,yBAAyB,EAAE,cAAc;EACzC,2BAA2B;EAC3B,gCAAgC;EAChC,oCAAoC,EAAE,cAAc;EACpD,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,2BAA2B;;AAE3B;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;;IAEE,iBAAiB;IACjB,kDAAkD;EACpD;AACF;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,2BAA2B,EAAE,SAAS;EACtC,oBAAoB,EAAE,UAAU;AAClC;;AAEA;;;EAGE,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;EAC9B,6DAA6D;EAC7D,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,8CAA8C;AAC9C;EACE,oCAAoC;EACpC,yBAAyB;EACzB,OAAO;AACT;;AAEA;EACE,oCAAoC,EAAE,uBAAuB;AAC/D;;AAEA,6EAA6E;AAC7E;EACE,yBAAyB;EACzB,oCAAoC;EACpC,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,8DAA8D;IAC9D,+CAA+C;IAC/C,qBAAqB;EACvB;EACA;IACE,8DAA8D;IAC9D,+CAA+C;IAC/C,qBAAqB;EACvB;AACF;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,OAAO;AACT;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA,gDAAgD;AAChD;;;EAGE,oCAAoC,EAAE,iBAAiB;EACvD,yBAAyB,EAAE,mBAAmB;EAC9C,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,oFAAoF;AACpF;;EAEE,oCAAoC,EAAE,iBAAiB;EACvD,yBAAyB,EAAE,mBAAmB;EAC9C,8BAA8B;EAC9B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;;;EAGE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,QAAQ;EACR,eAAe;AACjB;AACA;EACE,kDAAkD;EAClD,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,4BAA4B;IAC5B,YAAY;EACd;AACF;;AAEA,4BAA4B;AAC5B;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kDAAkD;AACpD;;AAEA,iCAAiC;AACjC;;;;;;;;;;EAUE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,sDAAsD;AACtD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;EAClD,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,+BAA+B,cAAc,EAAE;AAC/C,yBAAyB,yBAAyB,EAAE;AACpD;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,kDAAkD;AACpD;AACA,0BAA0B,yBAAyB,EAAE;AACrD,iCAAiC,cAAc,EAAE;AACjD,+BAA+B,yBAAyB,EAAE;AAC1D,4BAA4B,yBAAyB,EAAE,cAAc,EAAE;AACvE,4BAA4B,cAAc,EAAE;AAC5C,2BAA2B,cAAc,EAAE;AAC3C,yBAAyB,cAAc,EAAE;AACzC,gCAAgC,cAAc,EAAE;AAChD,+CAA+C,yBAAyB,EAAE;AAC1E,+BAA+B,cAAc,EAAE;AAC/C,oBAAoB,cAAc,EAAE;AACpC,kCAAkC,cAAc,EAAE;AAClD,wBAAwB,oCAAoC,EAAE,uCAAuC,EAAE;AACvG,oCAAoC,oCAAoC,EAAE;AAC1E,iDAAiD,mBAAmB,EAAE;AACtE,iDAAiD,mBAAmB,EAAE;AACtE,2DAA2D,yBAAyB,EAAE;AACtF,2DAA2D,mBAAmB,EAAE;AAChF,kCAAkC,gCAAgC,EAAE;AACpE,0BAA0B,cAAc,EAAE;AAC1C;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA,kDAAkD,cAAc,EAAE;AAClE,qBAAqB,cAAc,EAAE;AACrC,0BAA0B,cAAc,EAAE;;AAE1C,sFAAsF;AACtF;EACE,4BAA4B;EAC5B,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,OAAO;EACP,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;EAC3C,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kDAAkD;EAClD,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kDAAkD;EAClD,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kDAAkD;EAClD,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA,gCAAgC,cAAc,EAAE;AAChD;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA,+CAA+C,gBAAgB,EAAE,kDAAkD,EAAE;AACrH;kEACkE,mBAAmB,EAAE;AACvF;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;wEACwE,mBAAmB,EAAE;AAC7F;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;+BAC+B,cAAc,EAAE;;AAE/C;EACE;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,QAAQ;AACV;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,iBAAiB;AACnB;;AAEA;;EAEE,iDAAiD;EACjD,iBAAiB;AACnB;;AAEA;;EAEE,kDAAkD;EAClD,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,4CAA4C,iBAAiB,EAAE,QAAQ,EAAE;AACzE;EACE,aAAa,QAAQ,EAAE;EACvB,+DAA+D,QAAQ,EAAE;AAC3E;;AAEA,iFAAiF;AACjF;EACE,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,QAAQ;AACV;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,cAAc;EACd,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA,8BAA8B,cAAc,EAAE,kDAAkD,EAAE;AAClG,4BAA4B,cAAc,EAAE,kDAAkD,EAAE;;AAEhG;;;;EAIE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kDAAkD;EAClD,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;iCAGiC,mBAAmB,EAAE;;AAEtD,uCAAuC,YAAY,EAAE,mBAAmB,EAAE;;AAE1E;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,qBAAqB;EACrB,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kDAAkD;AACpD;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,kDAAkD;AACpD;;AAEA,6BAA6B,cAAc,EAAE;AAC7C,2BAA2B,gBAAgB,EAAE;AAC7C,wBAAwB,gBAAgB,EAAE,cAAc,EAAE,kDAAkD,EAAE;;AAE9G;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE,gBAAgB,EAAE;AAC1F;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,oCAAoC;EACpC,8BAA8B;EAC9B,8BAA8B;EAC9B,uDAAuD;AACzD;;AAEA,sBAAsB,aAAa,EAAE,QAAQ,EAAE;AAC/C,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,YAAY,EAAE,QAAQ,EAAE;AAClG;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAwB,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,qBAAqB,EAAE,sBAAsB,EAAE;AACvJ,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D;;wCAEwC,0BAA0B,EAAE,mBAAmB,EAAE;;AAEzF;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA,iCAAiC,aAAa,EAAE,gBAAgB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AAChG,wCAAwC,iDAAiD,EAAE;AAC3F,wCAAwC,kDAAkD,EAAE;AAC5F,uCAAuC,iDAAiD,EAAE;AAC1F,iCAAiC,yCAAyC,EAAE;AAC5E,kCAAkC,yCAAyC,EAAE;AAC7E,+BAA+B,yCAAyC,EAAE;AAC1E,sBAAsB,eAAe,EAAE,8BAA8B,EAAE;;AAEvE,aAAa,cAAc,EAAE,iCAAiC,EAAE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA,yCAAyC,iCAAiC,EAAE;AAC5E,6BAA6B,eAAe,EAAE;AAC9C,kBAAkB,cAAc,EAAE,YAAY,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,kDAAkD,EAAE,gBAAgB,EAAE;AACvL,iBAAiB,cAAc,EAAE,cAAc,EAAE,kDAAkD,EAAE,gBAAgB,EAAE;AACvH,mBAAmB,cAAc,EAAE,cAAc,EAAE,iDAAiD,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;AAC1K,sCAAsC,cAAc,EAAE,6BAA6B,EAAE,8BAA8B,EAAE;AACrH,uCAAuC,cAAc,EAAE;AACvD,yCAAyC,cAAc,EAAE,6BAA6B,EAAE;AACxF,qBAAqB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,oBAAoB,EAAE;AACrF;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iDAAiD;EACjD,iBAAiB;EACjB,uBAAuB;AACzB;AACA,8BAA8B,qBAAqB,EAAE,cAAc,EAAE;;AAErE,yGAAyG;AACzG;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,kDAAkD;AACpD;;AAEA,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACvE;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA,mCAAmC,WAAW,EAAE,mBAAmB,EAAE;AACrE,uBAAuB,cAAc,EAAE,kCAAkC,EAAE,mBAAmB,EAAE;;AAEhG;EACE,aAAa;EACb,qBAAqB;EACrB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA,2BAA2B,cAAc,EAAE,kDAAkD,EAAE;AAC/F,yBAAyB,kDAAkD,EAAE;AAC7E,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,gBAAgB,EAAE,cAAc,EAAE,kDAAkD,EAAE;AAC/K,sBAAsB,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE,YAAY,EAAE;AAChH,wBAAwB,aAAa,EAAE,oBAAoB,EAAE,SAAS,EAAE;AACxE,wBAAwB,aAAa,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,6DAA6D,EAAE,0BAA0B,EAAE,kDAAkD,EAAE;AACtO,2BAA2B,WAAW,YAAY,EAAE,EAAE,MAAM,UAAU,EAAE,EAAE;;AAE1E;qBACqB,cAAc,EAAE;AACrC,2BAA2B,qBAAqB,EAAE,mBAAmB,EAAE,4CAA4C,EAAE;AACrH;6BAC6B,qBAAqB,EAAE;AACpD,8BAA8B,cAAc,EAAE;AAC9C,gCAAgC,cAAc,EAAE;AAChD,4BAA4B,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACxF,oCAAoC,cAAc,EAAE;AACpD,kCAAkC,cAAc,EAAE;AAClD;;;iCAGiC,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC7F;;;uCAGuC,mBAAmB,EAAE;AAC5D,0BAA0B,qBAAqB,EAAE;AACjD,2BAA2B,cAAc,EAAE;AAC3C,0BAA0B,cAAc,EAAE;AAC1C,gCAAgC,cAAc,EAAE;AAChD;4BAC4B,cAAc,EAAE;AAC5C,mCAAmC,cAAc,EAAE;AACnD,8BAA8B,cAAc,EAAE;AAC9C,qCAAqC,6DAA6D,EAAE,0BAA0B,EAAE;AAChI,qBAAqB,gCAAgC,EAAE,8BAA8B,EAAE,sDAAsD,EAAE;AAC/I,yBAAyB,cAAc,EAAE;AACzC,0BAA0B,qBAAqB,EAAE,cAAc,EAAE;AACjE,gCAAgC,mBAAmB,EAAE,WAAW,EAAE;AAClE,0BAA0B,cAAc,EAAE;AAC1C;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA,4BAA4B,qBAAqB,EAAE;AACnD,mBAAmB,qBAAqB,EAAE;AAC1C,0BAA0B,cAAc,EAAE;AAC1C,+CAA+C,oCAAoC,EAAE;AACrF,uBAAuB,cAAc,EAAE;AACvC,yBAAyB,cAAc,EAAE;AACzC,4CAA4C,cAAc,EAAE;AAC5D,6CAA6C,cAAc,EAAE;AAC7D,+CAA+C,cAAc,EAAE;AAC/D,0BAA0B,qBAAqB,EAAE,cAAc,EAAE;AACjE,oCAAoC,qBAAqB,EAAE,cAAc,EAAE;AAC3E,yBAAyB,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACrF,gCAAgC,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC5F,6BAA6B,cAAc,EAAE;AAC7C,0BAA0B,cAAc,EAAE;AAC1C,iCAAiC,cAAc,EAAE;AACjD,2BAA2B,cAAc,EAAE;AAC3C,8BAA8B,qBAAqB,EAAE,6DAA6D,EAAE,0BAA0B,EAAE;;AAEhJ;EACE,qBAAqB,iBAAiB,EAAE;AAC1C;;AAEA;EACE;uCACqC,sBAAsB,EAAE,gBAAgB,EAAE;EAC/E,qBAAqB,cAAc,EAAE,iBAAiB,EAAE,WAAW,EAAE;EACrE,uBAAuB,iBAAiB,EAAE;EAC1C,0BAA0B,kDAAkD,EAAE;EAC9E,uBAAuB,iBAAiB,EAAE;EAC1C,qBAAqB,aAAa,EAAE,SAAS,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;EAC1G,oBAAoB,eAAe,EAAE,gBAAgB,EAAE;EACvD,cAAc,oDAAoD,EAAE,sBAAsB,EAAE,WAAW,EAAE;EACzG,sBAAsB,oDAAoD,EAAE,sBAAsB,EAAE;EACpG,mBAAmB,uBAAuB,EAAE,sBAAsB,EAAE;EACpE,yBAAyB,WAAW,EAAE,8BAA8B,EAAE;AACxE;;AAEA;EACE;IACE,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;EACV;EACA;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,aAAa;EACf;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;EACd;EACA;IACE,cAAc;IACd,WAAW;EACb;AACF;;AAEA,wEAAwE;AACxE;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iCAAiC,eAAe,EAAE;AAClD,gEAAgE,cAAc,EAAE;AAChF;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,8BAA8B,aAAa,EAAE,QAAQ,EAAE;AACvD,mDAAmD,mBAAmB,EAAE;AACxE,yBAAyB,cAAc,EAAE;AACzC;EACE,mBAAmB;EACnB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iDAAiD;EACjD,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,+BAA+B;AACjC;;AAEA,sEAAsE,cAAc,EAAE;AACtF,0BAA0B,cAAc,EAAE;AAC1C,oCAAoC,sBAAsB,EAAE;AAC5D;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;6CAC6C,mBAAmB,EAAE;AAClE,6CAA6C,+BAA+B,EAAE;AAC9E,iCAAiC,4BAA4B,EAAE;;AAE/D;EACE,eAAe,wBAAwB,EAAE;EACzC,mDAAmD,mBAAmB,EAAE;EACxE,oBAAoB,YAAY,EAAE;AACpC;;AAEA,yDAAyD;AACzD;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB","sourcesContent":["/* ==============================\n   Kitchen Display System Styles\n   ============================== */\n\n/* ===== Layout ===== */\n.kds-screen-layout {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 174px);\n  overflow: hidden;\n  /* width: 100%; */\n  box-sizing: border-box;\n\n  /* Font scaling: every KDS font size adds --kds-font-delta (set on <html> by the\n     Font Change menu: Small -2px, Medium 0, Large +2px) so portaled drawers follow too. */\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  transition: font-size 0.3s ease;\n}\n\n/* ===== Slots ===== */\n.kds-slots-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: 4px 0px;\n}\n\n.kds-slots-container::-webkit-scrollbar {\n  display: none;\n}\n\n.kds-slot-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 4px;\n  border: 1px solid var(--blue-b0, #0860e6);\n  cursor: pointer;\n  color: var(--blue-b0, #0860e6);\n  white-space: nowrap;\n  transition: 0.2s;\n}\n\n.kds-slot-item:hover {\n  background-color: rgba(8, 96, 230, 0.08);\n}\n\n.kds-selected-slot {\n  background-color: var(--blue-b0, #0860e6);\n  color: white;\n}\n\n.kds-slot-time {\n  font-size: calc(0.875rem + var(--kds-font-delta, 0px));\n  font-weight: 600;\n}\n\n.kds-slot-count {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  background-color: var(--blue-b0, #0860e6);\n  color: white;\n  font-size: calc(0.75rem + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  padding: 4px;\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #c1c1c1;\n}\n\n.kds-slot-count-selected {\n  background-color: white;\n  color: var(--blue-b0, #0860e6);\n  border: 1px solid var(--blue-b0, #0860e6);\n}\n\n.kds-slot-close-icon {\n  width: 16px;\n  height: 16px;\n  color: white;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.kds-no-slot-container {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.kds-no-slot {\n  font-size: calc(0.875rem + var(--kds-font-delta, 0px));\n  font-weight: 600;\n  color: #999;\n}\n\n.kds-slot-loading {\n  font-size: calc(0.875rem + var(--kds-font-delta, 0px));\n  color: #666;\n  padding: 4px 0;\n}\n\n/* ===== Main Layout ===== */\n.kds-main-layout {\n  display: flex;\n  justify-content: space-between;\n  flex: 1;\n  min-height: 0;\n  overflow: visible;\n  padding: 8px 0;\n  gap: 16px;\n}\n\n.kds-orders-container {\n  display: flex;\n  min-height: 0;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  zoom: 1;\n  flex: 1;\n  min-width: 0;\n}\n\n/* ===== Scrollable Container (horizontal scroll working) ===== */\n.kds-main-order-container {\n  padding: 12px;\n  height: calc(100vh - 140px);\n  overflow-x: hidden;\n  overflow-y: auto;\n  white-space: normal;\n  box-sizing: border-box;\n  display: block; /* Removed grid for JS masonry */\n\n  width: 100%;\n  -webkit-overflow-scrolling: touch;\n  scroll-behavior: smooth;\n}\n\n.kds-main-order-container .horizontal-loader,\n.kds-main-order-container .no-orders-text {\n  grid-column: 1 / -1;\n  width: 100%;\n}\n\n@media (max-width: 900px) {\n  .kds-section-header,\n  .kds-section-right-group {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n}\n\n/* ===== Scrollbar Styling ===== */\n.kds-main-order-container::-webkit-scrollbar {\n  width: 10px;\n}\n.kds-main-order-container::-webkit-scrollbar-thumb {\n  background-color: #d0d0d0;\n  border-radius: 10px;\n}\n.kds-main-order-container::-webkit-scrollbar-track {\n  background: #f5f5f5;\n}\n.kds-main-order-container {\n  scrollbar-width: thin;\n  scrollbar-color: #d0d0d0 #f5f5f5;\n}\n\n/* .kds-main-order-container {\n  overscroll-behavior-x: contain;\n  overscroll-behavior-y: auto;\n} */\n\n/* .kds-screen-layout {\n  overscroll-behavior: contain;\n  overscroll-behavior-x: contain;\n} */\n\n.kds-screen-layout {\n  overscroll-behavior: contain;\n}\n\n/* ===== Section Header ===== */\n.kds-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px; /* gap-3 is 12px */\n  border-bottom: 1px solid #e2e8f0; /* border-b border-slate-200 */\n  background: #ffffff;\n  padding: 12px 16px; /* px-4 py-3 is 16px 12px */\n  margin: 0;\n}\n\n.kds-section-left {\n  display: flex;\n  align-items: center;\n  gap: 8px; /* gap-2 is 8px */\n}\n\n.kds-section-dot {\n  height: 10px; /* h-2.5 is 10px */\n  width: 10px; /* w-2.5 is 10px */\n  border-radius: 50%; /* rounded-full */\n  background-color: #334155; /* bg-slate-700 */\n}\n\n.kds-section-header h2 {\n  font-size: calc(14px + var(--kds-font-delta, 0px)); /* text-sm is 14px */\n  font-weight: 700; /* font-bold */\n  text-transform: uppercase; /* uppercase */\n  letter-spacing: 0.05em; /* tracking-wider */\n  color: #1e293b; /* text-slate-800 */\n  margin: 0;\n  line-height: normal;\n}\n\n.count-badge {\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 50px;\n  padding: 2px 10px;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  font-weight: 600;\n  border: 1px solid #e2e8f0;\n  background-color: #f1f5f9;\n  color: #334155;\n  width: auto;\n  height: auto;\n  gap: 0;\n  line-height: normal;\n}\n\n.kds-section-right-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.kds-date-container {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n/* Reused OdsDateFilter, sized to sit level with the 36px settings button */\n.kds-date-container .ods-date-filter-pill {\n  height: 36px;\n  padding: 0 12px;\n  border-radius: 50px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.kds-date-container .ods-date-filter-pill:hover {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n}\n\n.kds-date-container .ods-date-filter-text {\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #475569;\n  letter-spacing: normal;\n}\n\n/* Header sits at the right edge — open the 280px calendar right-aligned so it stays on screen */\n.kds-date-container .ods-date-dropdown {\n  left: auto;\n  right: 0;\n}\n\n.kds-settings-icon {\n  width: 16px; /* h-4 */\n  height: 16px; /* w-4 */\n}\n\n/* ===== Order Card ===== */\n.kds-order-card {\n  display: flex;\n  flex-direction: column;\n  width: 100% !important;\n  background-color: #ffffff !important;\n  break-inside: avoid;\n  margin: 0 !important;\n  padding: 16px !important;\n  box-sizing: border-box;\n\n  border-radius: 16px !important; /* rounded-2xl */\n  border: 1px solid #e2e8f0 !important; /* border-slate-200 */\n  box-shadow: 0 8px 26px rgba(15, 23, 42, 0.07) !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.kds-order-card:hover {\n  transform: translateY(-2px) !important; /* hover:-translate-y-0.5 */\n  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.1) !important; /* hover:shadow */\n}\n\n/* ===== Order Header ===== */\n.kds-order-card-header {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0px !important; /* reset gap, row margins handle it */\n  align-self: stretch;\n  margin-bottom: 12px !important;\n}\n\n/* Header row 1 */\n.kds-ref-header-row-1 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n}\n\n.kds-ref-header-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.kds-ref-order-no {\n  font-size: calc(15px + var(--kds-font-delta, 0px)) !important;\n  font-weight: 600 !important;\n  color: #1e293b !important; /* text-slate-800 */\n  margin: 0 !important;\n}\n\n.kds-ref-edit-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: transparent;\n  border: none;\n  color: #64748b; /* text-slate-500 */\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.kds-ref-edit-btn:hover {\n  color: #0f172a; /* text-slate-900 */\n  background-color: #f1f5f9;\n}\n\n.kds-ref-edit-icon {\n  width: 16px;\n  height: 16px;\n}\n\n.kds-ref-header-right {\n  text-align: right;\n}\n\n.kds-ref-time-prep-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #64748b; /* text-slate-500 */\n}\n\n.kds-ref-prep-tag {\n  font-weight: 600 !important;\n  color: #c46b21 !important;\n}\n\n/* Header row 2 */\n.kds-ref-header-row-2 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  margin-top: 12px; /* mt-3 */\n}\n\n/* Customizing the existing PlatformBadge components to look premium */\n.kds-ref-platform-left .platform-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #334155 !important; /* slate-700 */\n}\n\n.kds-ref-platform-left .platform-icon {\n  width: 16px;\n  height: 16px;\n  object-fit: contain;\n}\n\n.kds-ref-info-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  color: #64748b; /* text-slate-500 */\n}\n\n.kds-ref-kot-token {\n  font-weight: 500;\n  color: #334155; /* text-slate-700 */\n}\n\n.kds-ref-divider {\n  color: #cbd5e1; /* text-slate-300 */\n}\n\n.kds-ref-sub-order-type {\n  color: #64748b; /* text-slate-500 */\n}\n\n/* Header row 3 */\n.kds-ref-header-row-3 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  margin-top: 8px; /* mt-2 */\n}\n\n.kds-ref-customer-name {\n  font-size: calc(13px + var(--kds-font-delta, 0px)) !important;\n  color: #475569 !important; /* text-slate-600 */\n  margin: 0 !important;\n  font-weight: 400;\n}\n\n.kds-ref-table-info {\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #64748b;\n  background-color: #f1f5f9;\n  padding: 2px 8px;\n  border-radius: 50px;\n}\n\n.chevron-icon {\n  width: 20px;\n  height: 20px;\n  box-sizing: border-box;\n  padding: 0px 2px;\n  margin-left: 8px;\n}\n\n.edit-icon {\n  width: 16px;\n  height: 16px;\n  color: #252b37;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.edit-icon:hover {\n  color: #007aff;\n}\n\n.prep-time {\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  font-weight: 700;\n  color: #e04a00;\n  white-space: nowrap;\n}\n\n.platform-container {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.order-info {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  color: #555;\n}\n\n.platform-badge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 600;\n  border-radius: 4px;\n  padding: 2px 0px;\n}\n\n.platform-icon {\n  width: 14px;\n  height: 14px;\n  object-fit: contain;\n}\n\n.platform-generic-icon {\n  width: 14px;\n  height: 14px;\n  color: #333;\n}\n\n.platform-batch-table-key {\n  color: #717680;\n  text-align: center;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n/* ===== Order Body ===== */\n.kds-order-body {\n  border-top: 1px dashed #cbd5e1 !important; /* border-dashed divide-slate-200 */\n  border-bottom: 1px dashed #cbd5e1 !important;\n  margin-top: 12px !important;\n  padding: 4px 0 !important;\n  gap: 0px !important; /* reset gap because py-3/margin manages spacing */\n}\n\n.kds-order-body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.kds-order-body::-webkit-scrollbar-track {\n  background: #f8fafc;\n  border-radius: 3px;\n}\n\n.kds-order-body::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.kds-order-body::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n.item-block {\n  padding: 12px 0 !important; /* py-3 */\n}\n\n/* Add dividing border between children inside the body (divide-y divide-dashed) */\n.kds-order-body > div + div {\n  border-top: 1px dashed #cbd5e1 !important;\n}\n\n.select-all-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px; /* gap-3 is 12px */\n  padding: 12px 0 !important; /* py-3 is 12px padding */\n}\n\n.select-all-label {\n  display: inline-flex;\n  min-width: 0;\n  align-items: center;\n  gap: 10px; /* gap-2.5 is 10px */\n  font-size: calc(13px + var(--kds-font-delta, 0px)); /* text-[13px] */\n  font-weight: 500; /* font-medium */\n  color: #334155; /* text-slate-700 */\n  cursor: pointer;\n}\n\n.select-all-count {\n  font-size: calc(12px + var(--kds-font-delta, 0px)); /* text-[12px] */\n  font-weight: 500; /* font-medium */\n  color: #94a3b8; /* text-slate-400 */\n}\n\n.item-line {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-width: 0;\n}\n\n.item-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  flex: 1 1 auto;\n  min-width: 0;\n  cursor: pointer;\n}\n\n/* Modern Checkbox Style */\n.kds-order-body input[type=\"checkbox\"],\n.select-all-checkbox {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 16px !important;\n  height: 16px !important;\n  border: 1px solid #cbd5e1 !important;\n  border-radius: 4px !important;\n  outline: none;\n  cursor: pointer;\n  display: inline-grid;\n  place-content: center;\n  background-color: #ffffff !important;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  margin-top: 2px !important;\n  flex-shrink: 0;\n}\n\n.kds-order-body input[type=\"checkbox\"]:checked,\n.select-all-checkbox:checked {\n  background-color: #2a71ff !important;\n  border-color: #2a71ff !important;\n}\n\n.kds-order-body input[type=\"checkbox\"]:checked::before,\n.select-all-checkbox:checked::before {\n  content: \"\";\n  width: 8px;\n  height: 5px;\n  border-left: 2px solid white;\n  border-bottom: 2px solid white;\n  transform: rotate(-45deg) translate(1px, -1px);\n}\n\n.kds-order-body input[type=\"checkbox\"]:disabled {\n  background-color: #f1f5f9 !important;\n  border-color: #cbd5e1 !important;\n  cursor: not-allowed;\n}\n\n.item-name {\n  font-size: calc(13px + var(--kds-font-delta, 0px)) !important;\n  font-weight: 500 !important;\n  color: #1e293b !important; /* text-slate-800 */\n  line-height: 1.4;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.item-name.item-completed {\n  text-decoration: line-through;\n}\n\n.item-qty {\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #64748b; /* text-slate-500 */\n  margin-top: 0;\n  flex: 0 0 auto;\n}\n\n/* ===== Item Separator (Dotted Line) ===== */\n.item-separator {\n  display: none !important; /* Separators are now handled dynamically by item borders */\n}\n\n/* ===== Notes & Add-ons ===== */\n.kds-item-tags-inline {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  margin-left: 28px;\n  margin-top: 6px;\n  flex-wrap: wrap;\n}\n\n/* Note Pill: Amber style from reference */\n.kds-note-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background-color: #fffbeb !important;\n  color: #92400e !important;\n  padding: 3px 8px !important;\n  border-radius: 9999px !important;\n  border: 1px solid #fef3c6 !important;\n  box-shadow: none !important;\n}\n\n.kds-note-pill svg {\n  flex-shrink: 0;\n}\n\n.kds-note-dot {\n  width: 6px;\n  height: 6px;\n  background-color: #d97706 !important;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.kds-note-text {\n  font-size: calc(10px + var(--kds-font-delta, 0px)) !important;\n  font-weight: 500 !important;\n  color: #92400e !important;\n  white-space: normal;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n/* Addon Pill: Slate style */\n.kds-addon-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background-color: #f1f5f9 !important; /* slate-100 */\n  color: #475569 !important; /* slate-600 */\n  padding: 3px 8px !important;\n  border-radius: 9999px !important;\n  border: 1px solid #e2e8f0 !important; /* slate-200 */\n  box-shadow: none !important;\n}\n\n.kds-addon-plus {\n  color: #64748b !important;\n  font-weight: 600 !important;\n}\n\n.kds-addon-text {\n  font-size: calc(10px + var(--kds-font-delta, 0px)) !important;\n  color: #475569 !important;\n  font-weight: 500 !important;\n  white-space: nowrap;\n}\n\n/* ===== Responsive ===== */\n\n@media (max-width: 1020px) {\n  .kds-order-card {\n    width: 100% !important;\n  }\n}\n\n@media (max-width: 520px) {\n  .kds-item-tags-inline {\n    margin-left: 22px;\n    gap: 6px;\n  }\n\n  .kds-note-pill,\n  .kds-addon-pill {\n    padding: 5px 10px;\n    font-size: calc(12px + var(--kds-font-delta, 0px));\n  }\n}\n\n/* ===== Footer Buttons ===== */\n.kds-order-footer {\n  display: flex;\n  margin-top: 16px !important; /* mt-4 */\n  gap: 12px !important; /* gap-3 */\n}\n\n.start-btn,\n.reprint-btn,\n.ready-btn {\n  display: inline-flex !important;\n  height: 44px !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n  border-radius: 50px !important;\n  font-size: calc(13px + var(--kds-font-delta, 0px)) !important;\n  font-weight: 500 !important;\n  border: none !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n  box-shadow: none !important;\n}\n\n/* Reprint KOT button: blue light background */\n.reprint-btn {\n  background-color: #e8f3ff !important;\n  color: #2a71ff !important;\n  flex: 1;\n}\n\n.reprint-btn:hover:not([disabled]) {\n  background-color: #dcebff !important; /* hover:bg-[#dcebff] */\n}\n\n/* Complimentary blink: gentle pulsing border + shadow in Re-Print KOT blue */\n.reprint-btn-complimentary:not([disabled]) {\n  color: #2a71ff !important;\n  border: 2px solid #b7d5ff !important;\n  animation: reprint-blink 1.4s ease-in-out infinite !important;\n}\n\n.reprint-btn-complimentary:not([disabled]) .reprint-icon {\n  color: #2a71ff !important;\n}\n\n@keyframes reprint-blink {\n  0%,\n  100% {\n    background: linear-gradient(135deg, #e8f3ff, #ffffff, #ffffff);\n    box-shadow: 0 4px 12px rgba(42, 113, 255, 0.12);\n    border-color: #b7d5ff;\n  }\n  50% {\n    background: linear-gradient(135deg, #c9e2ff, #e8f3ff, #ffffff);\n    box-shadow: 0 4px 16px rgba(42, 113, 255, 0.32);\n    border-color: #2a71ff;\n  }\n}\n\n.ready-btn,\n.start-btn {\n  background-color: #7bcb89 !important;\n  color: #ffffff !important;\n  flex: 1;\n}\n\n.ready-btn:hover:not([disabled]),\n.start-btn:hover:not([disabled]) {\n  background-color: #6ab979 !important;\n}\n\n/* Disabled states: light slate from reference */\n.reprint-btn[disabled],\n.ready-btn[disabled],\n.start-btn[disabled] {\n  background-color: #f1f5f9 !important; /* bg-slate-100 */\n  color: #94a3b8 !important; /* text-slate-400 */\n  cursor: not-allowed !important;\n  opacity: 1 !important;\n}\n\n/* Cart closed: reprint looks disabled but stays clickable to surface the snackbar */\n.reprint-btn.reprint-btn-disabled,\n.reprint-btn.reprint-btn-disabled:hover {\n  background-color: #f1f5f9 !important; /* bg-slate-100 */\n  color: #94a3b8 !important; /* text-slate-400 */\n  cursor: not-allowed !important;\n  border: none !important;\n  animation: none !important;\n}\n\n.reprint-btn.reprint-btn-disabled .reprint-icon {\n  color: #94a3b8 !important;\n}\n\n/* Icons within buttons */\n.reprint-icon,\n.ready-icon,\n.chevron-icon {\n  width: 16px !important;\n  height: 16px !important;\n  margin: 0 !important;\n  color: inherit !important;\n}\n\n/* ===== Loader Spinner ===== */\n.loader {\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #007aff;\n  border-radius: 50%;\n  width: 14px;\n  height: 14px;\n  animation: spin 0.8s linear infinite;\n  display: inline-block;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* ===== Item Loader ===== */\n.item-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #007aff;\n  gap: 6px;\n  padding: 10px 0;\n}\n.item-loader p {\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  color: #555;\n}\n\n/* ===== Horizontal Loader ===== */\n.horizontal-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 12px;\n  height: 4px;\n  width: 100%;\n  position: relative;\n}\n.horizontal-loader-bar {\n  width: 50px;\n  height: 4px;\n  background: #007aff;\n  border-radius: 2px;\n  animation: load-horizontal 1s linear infinite;\n}\n\n.kds-orders-container > .horizontal-loader {\n  flex-shrink: 0;\n  margin-top: 0;\n}\n\n@keyframes load-horizontal {\n  0% {\n    transform: translateX(0);\n    opacity: 0.4;\n  }\n  50% {\n    transform: translateX(100px);\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(200px);\n    opacity: 0.4;\n  }\n}\n\n/* ===== Text States ===== */\n.loading-text,\n.no-orders-text {\n  text-align: center;\n  color: #888;\n  margin: 10px;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n}\n\n/* ===== Font Propagation ===== */\n.kds-order-card,\n.kds-order-body,\n.kds-order-footer,\n.kds-section-header,\n.no-orders-text,\n.order-info,\n.item-name,\n.item-qty,\n.kds-note-pill,\n.kds-addon-pill {\n  font-size: 1em;\n}\n\n.removed-item {\n  text-decoration: line-through;\n  opacity: 0.6;\n}\n\n/* Combo pill styling */\n.kds-combo-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 7px;\n  background-color: #0860e6;\n  border-radius: 4px;\n  margin-right: 6px;\n  margin-bottom: 4px;\n  flex-shrink: 0;\n}\n\n.kds-combo-text {\n  font-size: calc(10px + var(--kds-font-delta, 0px));\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: 0.02em;\n}\n\n/* Inline variant used in JobModal next to item name */\n.kds-combo-pill-inline {\n  margin-left: 6px;\n  margin-bottom: 0;\n  vertical-align: middle;\n}\n\n/* Complimentary pill styling */\n.kds-complimentary-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background-color: #dbeafe;\n  border: 1px solid #60a5fa;\n  border-radius: 12px;\n  margin-right: 6px;\n  margin-bottom: 4px;\n}\n\n.kds-gift-icon {\n  width: 14px;\n  height: 14px;\n  color: #2563eb;\n  flex-shrink: 0;\n}\n\n.kds-complimentary-text {\n  font-size: calc(0.75rem + var(--kds-font-delta, 0px));\n  color: #1e40af;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.customerNotes {\n  background-color: #fff9f2 !important;\n  color: #314158 !important;\n  width: 100%;\n  border: 1px solid #ffedd4 !important;\n  border-radius: 16px;\n  padding: 8px 10px;\n  margin-top: 6px;\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  box-shadow: 0 1px 2px 0 rgba (0, 0, 0, 0.05);\n}\n\n.kdsCustomerNotesUpperWrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #f54900;\n  font-weight: 700;\n  font-size: calc(11px + var(--kds-font-delta, 0px));\n  margin-bottom: 4px;\n}\n\n/* ═══ DARK THEME — KDS ═══ */\n.dark .kds-orders-container {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n.dark .kds-section-header {\n  background: #1e293b;\n  border-bottom-color: #334155;\n}\n.dark .kds-section-header h2 { color: #f1f5f9; }\n.dark .kds-section-dot { background-color: #64748b; }\n.dark .count-badge {\n  background-color: #0f172a;\n  border-color: #334155;\n  color: #94a3b8;\n}\n.dark .kds-order-card {\n  background-color: #1e293b !important;\n  border-color: #334155 !important;\n}\n.dark .kds-order-card:hover {\n  box-shadow: 0 14px 34px rgba(0,0,0,0.4) !important;\n}\n.dark .kds-ref-order-no { color: #f1f5f9 !important; }\n.dark .kds-ref-time-prep-group { color: #94a3b8; }\n.dark .kds-ref-customer-name { color: #94a3b8 !important; }\n.dark .kds-ref-table-info { background-color: #0f172a; color: #64748b; }\n.dark .kds-ref-info-right { color: #64748b; }\n.dark .kds-ref-kot-token { color: #94a3b8; }\n.dark .kds-ref-divider { color: #475569; }\n.dark .kds-ref-sub-order-type { color: #64748b; }\n.dark .kds-ref-platform-left .platform-badge { color: #94a3b8 !important; }\n.dark .platform-generic-icon { color: #94a3b8; }\n.dark .order-info { color: #64748b; }\n.dark .platform-batch-table-key { color: #64748b; }\n.dark .kds-order-body { border-top-color: #334155 !important; border-bottom-color: #334155 !important; }\n.dark .kds-order-body > div + div { border-top-color: #334155 !important; }\n.dark .kds-order-body::-webkit-scrollbar-track { background: #0f172a; }\n.dark .kds-order-body::-webkit-scrollbar-thumb { background: #334155; }\n.dark .kds-main-order-container::-webkit-scrollbar-thumb { background-color: #334155; }\n.dark .kds-main-order-container::-webkit-scrollbar-track { background: #0f172a; }\n.dark .kds-main-order-container { scrollbar-color: #334155 #0f172a; }\n.dark .select-all-label { color: #94a3b8; }\n.dark .kds-date-container .ods-date-filter-pill {\n  border-color: #334155;\n  background: #1e293b;\n}\n.dark .kds-date-container .ods-date-filter-pill:hover {\n  border-color: #475569;\n  background: #334155;\n}\n.dark .kds-date-container .ods-date-filter-text { color: #94a3b8; }\n.dark .kds-no-slot { color: #64748b; }\n.dark .kds-slot-loading { color: #475569; }\n\n/* Orders view: Processing stays in one horizontal rail; Pending keeps its own rail. */\n.kds-screen-layout.kds-orders-screen {\n  height: calc(100dvh - 174px);\n  min-height: 0;\n}\n\n.kds-main-layout.kds-orders-layout,\n.kds-main-layout.kds-tables-layout {\n  min-height: 0;\n  overflow: hidden;\n}\n\n.kds-orders-rail-container {\n  display: block;\n  flex: 1;\n  height: auto;\n  min-height: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  overscroll-behavior-x: contain;\n  -webkit-overflow-scrolling: touch;\n}\n\n.kds-processing-rail {\n  display: flex;\n  align-items: stretch;\n  flex-flow: row nowrap;\n  gap: 14px;\n  width: max-content;\n  min-width: 100%;\n  height: 100%;\n  padding: 2px 2px 12px;\n  box-sizing: border-box;\n}\n\n.kds-processing-rail:focus-visible,\n.kds-orders-rail-container:focus-visible {\n  outline: 2px solid #ad5b20;\n  outline-offset: -2px;\n}\n\n.kds-processing-rail > .kds-order-card {\n  flex: 0 0 clamp(280px, 30vw, 360px);\n  width: clamp(280px, 30vw, 360px) !important;\n  min-width: 0;\n  min-height: 0;\n  height: 100%;\n  max-height: 100%;\n  overflow: hidden;\n}\n\n.kds-processing-rail > .kds-order-card .kds-order-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior-y: contain;\n}\n\n.kds-processing-controls {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  flex-wrap: wrap;\n}\n\n.kds-processing-control {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #687582;\n  font-size: calc(11px + var(--kds-font-delta, 0px));\n  font-weight: 700;\n  letter-spacing: .04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.kds-processing-control .MuiSelect-select {\n  max-width: 160px;\n  min-height: 34px;\n  padding: 0 28px 0 9px !important;\n  border: 1px solid #d8e0e5;\n  border-radius: 8px;\n  background: #f8faf9;\n  color: #263640;\n  font: inherit;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  letter-spacing: normal;\n  text-transform: none;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n}\n\n.kds-processing-control .MuiSelect-select:focus-visible,\n.kds-clear-filter:focus-visible,\n.kds-no-filter-results button:focus-visible {\n  outline: 2px solid #ad5b20;\n  outline-offset: 2px;\n}\n\n.kds-clear-filter,\n.kds-no-filter-results button {\n  min-height: 32px;\n  padding: 0 10px;\n  border: 1px solid #e3c9b7;\n  border-radius: 7px;\n  background: #fff8f2;\n  color: #914c21;\n  font: inherit;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.kds-results-count {\n  color: #71808a;\n  font-size: calc(11px + var(--kds-font-delta, 0px));\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.kds-no-filter-results {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  flex: 1;\n  min-height: 150px;\n  color: #697781;\n}\n\n.kds-no-filter-results p {\n  margin: 0;\n}\n\n.dark .kds-processing-control { color: #b3c0c8; }\n.dark .kds-processing-control .MuiSelect-select {\n  border-color: #4b5963;\n  background: #26343e;\n  color: #edf2f4;\n}\n.kds-processing-menu-paper {\n  max-height: 280px !important;\n  border: 1px solid #d8e0e5;\n  border-radius: 8px !important;\n  background: #f8faf9 !important;\n  color: #263640 !important;\n}\n.kds-processing-menu-paper .MuiMenuItem-root { min-height: 36px; font-size: calc(12px + var(--kds-font-delta, 0px)); }\n.kds-processing-menu-paper .MuiMenuItem-root.Mui-selected,\n.kds-processing-menu-paper .MuiMenuItem-root.Mui-selected:hover { background: #e8efeb; }\n.dark .kds-processing-menu-paper {\n  border-color: #4b5963;\n  background: #26343e !important;\n  color: #edf2f4 !important;\n}\n.dark .kds-processing-menu-paper .MuiMenuItem-root.Mui-selected,\n.dark .kds-processing-menu-paper .MuiMenuItem-root.Mui-selected:hover { background: #3a4b43; }\n.dark .kds-clear-filter,\n.dark .kds-no-filter-results button {\n  border-color: #694c3b;\n  background: #382c26;\n  color: #f1c5a4;\n}\n.dark .kds-results-count,\n.dark .kds-no-filter-results { color: #a5b2ba; }\n\n@media (max-width: 900px) {\n  .kds-main-layout.kds-orders-layout {\n    gap: 10px;\n  }\n  .kds-orders-layout .kds-section-left {\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 600px) {\n  .kds-processing-controls {\n    width: 100%;\n  }\n  .kds-processing-control .MuiSelect-select {\n    max-width: 135px;\n  }\n}\n\n.item-line .kds-item-preparation.is-inline {\n  display: block;\n  flex: 0 1 auto;\n  min-width: 0;\n  margin: 0;\n  padding: 3px 5px;\n  border-top: 0;\n  border-right: 0;\n  border-bottom: 0;\n  border-radius: 0;\n  background: transparent;\n  white-space: nowrap;\n}\n\n.item-line .kds-item-preparation.is-inline .kds-prep-summary {\n  flex-wrap: nowrap;\n  gap: 5px;\n}\n\n.item-line .kds-item-preparation.is-inline .kds-prep-estimate,\n.item-line .kds-item-preparation.is-inline .kds-prep-countdown {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0;\n  line-height: 1.05;\n}\n\n.kds-item-preparation.is-inline .kds-prep-estimate > span,\n.kds-item-preparation.is-inline .kds-prep-countdown > span {\n  font-size: calc(9px + var(--kds-font-delta, 0px));\n  line-height: 1.05;\n}\n\n.kds-item-preparation.is-inline .kds-prep-estimate strong,\n.kds-item-preparation.is-inline .kds-prep-countdown strong {\n  font-size: calc(11px + var(--kds-font-delta, 0px));\n  line-height: 1.05;\n}\n\n.order-item-preview-row {\n  align-items: center;\n}\n\n.order-item-preview-row .order-item-preview-name {\n  flex: 1 1 auto;\n}\n\n.order-item-preview-row .kds-item-preparation.is-inline {\n  flex: 0 0 auto;\n  margin: 0;\n  padding: 2px 4px;\n}\n\n.order-item-preview-row .kds-prep-summary { flex-wrap: nowrap; gap: 4px; }\n@media (max-width: 600px) {\n  .item-line { gap: 5px; }\n  .item-line .kds-item-preparation.is-inline .kds-prep-summary { gap: 4px; }\n}\n\n/* Rush mode keeps the same one-row rail while tightening each ticket's rhythm. */\n.kds-rush-mode .kds-processing-rail {\n  gap: 9px;\n}\n\n.kds-rush-mode .kds-processing-rail > .kds-order-card {\n  flex-basis: 200px;\n  width: 200px !important;\n  padding: 11px !important;\n  border-radius: 12px !important;\n}\n\n.kds-rush-mode .kds-order-card-header {\n  margin-bottom: 7px !important;\n}\n\n.kds-rush-mode .kds-ref-header-row-2 {\n  margin-top: 7px;\n}\n\n.kds-rush-mode .kds-ref-header-row-3 {\n  margin-top: 5px;\n}\n\n.kds-rush-mode .kds-order-body {\n  margin-top: 7px !important;\n  padding: 1px 0 !important;\n}\n\n.kds-rush-mode .item-block {\n  padding: 6px 0 !important;\n}\n\n.kds-rush-mode .kds-item-tags-inline {\n  margin-top: 3px;\n  margin-left: 23px;\n  gap: 4px;\n}\n\n.kds-rush-mode .kds-note-pill,\n.kds-rush-mode .kds-addon-pill {\n  padding: 2px 6px !important;\n}\n\n.kds-rush-mode .kds-order-footer {\n  margin-top: 8px !important;\n  gap: 7px !important;\n}\n\n.kds-rush-mode .kds-order-footer .start-btn,\n.kds-rush-mode .kds-order-footer .reprint-btn {\n  height: 36px !important;\n}\n\n.kds-item-ready-button {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  min-height: 28px;\n  padding: 0 8px;\n  border: 1px solid #b6d8c2;\n  border-radius: 7px;\n  background: #edf7ef;\n  color: #28643e;\n  font: inherit;\n  font-size: calc(11px + var(--kds-font-delta, 0px));\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.kds-item-ready-button svg {\n  width: 13px;\n  height: 13px;\n}\n\n.kds-item-ready-button:hover:not(:disabled) {\n  background: #deefdf;\n  border-color: #7eae8c;\n}\n\n.kds-item-ready-button:focus-visible {\n  outline: 2px solid #38784b;\n  outline-offset: 2px;\n}\n\n.kds-item-ready-button:disabled {\n  cursor: not-allowed;\n}\n\n.kds-item-ready-button.is-confirmed {\n  background: #e7f2e9;\n  border-color: #c7dec9;\n  color: #3e6948;\n  opacity: 0.82;\n}\n\n.kds-rush-item-label {\n  border: 0;\n  border-radius: 6px;\n  padding: 5px 3px;\n  min-height: 40px;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.kds-rush-item-label:hover:not(:disabled) {\n  background: rgba(56, 120, 75, .1);\n}\n\n.kds-rush-item-label:focus-visible {\n  outline: 2px solid #38784b;\n  outline-offset: 2px;\n}\n\n.kds-rush-item-label:disabled {\n  cursor: default;\n}\n\n/* SlotList is portaled into the OrdersPage header when the host target exists. */\n#kds-slots-header-mount {\n  display: flex;\n  flex: 1 1 auto;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.kds-header-slots-container {\n  width: 100%;\n  min-width: 0;\n  padding: 0;\n  overflow-x: auto;\n  overflow-y: visible;\n  scrollbar-width: thin;\n}\n\n.kds-header-slots-container .board-slots-container {\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n  gap: 8px;\n  width: max-content;\n}\n\n.kds-header-slots-container .slotItem {\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n/* Rush: five-column, sequential ticket board + consolidated prep ledger. */\n.kds-rush-mode.kds-main-order-container {\n  overflow: auto;\n  overscroll-behavior: contain;\n  scrollbar-width: thin;\n}\n\n.rush-prep-summary {\n  display: flex;\n  flex: 0 0 184px;\n  flex-direction: column;\n  min-width: 0;\n  max-height: 100%;\n  overflow: hidden;\n  border: 1px solid #d9dfd8;\n  border-radius: 12px;\n  background: #f5f6f0;\n  color: #26322c;\n  box-shadow: 0 4px 14px rgba(36, 51, 40, .08);\n}\n\n.rush-summary-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 17px 15px 13px;\n  border-bottom: 1px solid #dfe5de;\n}\n\n.rush-summary-eyebrow {\n  color: #748278;\n  font-size: calc(10px + var(--kds-font-delta, 0px));\n  font-weight: 750;\n  letter-spacing: .12em;\n  text-transform: uppercase;\n}\n\n.rush-summary-header h2 {\n  margin: 4px 0 0;\n  color: #29382f;\n  font-size: calc(17px + var(--kds-font-delta, 0px));\n  letter-spacing: -.02em;\n}\n\n.rush-summary-total {\n  display: grid;\n  width: 38px;\n  height: 38px;\n  place-items: center;\n  border: 1px solid #ced9cc;\n  border-radius: 11px;\n  background: #eaf1e7;\n  color: #405942;\n  font-size: calc(18px + var(--kds-font-delta, 0px));\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n}\n\n.rush-summary-accept {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 12px 13px;\n  border-bottom: 1px solid #dfe5de;\n}\n\n.rush-summary-accept > div {\n  display: grid;\n  gap: 3px;\n  min-width: 0;\n}\n\n.rush-summary-accept strong { color: #344238; font-size: calc(12px + var(--kds-font-delta, 0px)); }\n.rush-summary-accept span { color: #78857b; font-size: calc(10px + var(--kds-font-delta, 0px)); }\n\n.rush-summary-accept button,\n.rush-summary-state button,\n.rush-inline-error button,\n.rush-board-state button {\n  min-height: 32px;\n  padding: 0 10px;\n  border: 1px solid #bfd0bc;\n  border-radius: 7px;\n  background: #e7f0e4;\n  color: #38513b;\n  font: inherit;\n  font-size: calc(11px + var(--kds-font-delta, 0px));\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.rush-summary-accept button:hover:not(:disabled),\n.rush-summary-state button:hover,\n.rush-inline-error button:hover,\n.rush-board-state button:hover { background: #dbe9d8; }\n\n.rush-summary-accept button:disabled { opacity: .46; cursor: not-allowed; }\n\n.rush-summary-list {\n  min-height: 0;\n  overflow-y: auto;\n  padding: 4px 13px 14px;\n}\n\n.rush-summary-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: baseline;\n  gap: 5px 8px;\n  padding: 11px 2px 10px;\n  border-bottom: 1px solid #dfe5de;\n}\n\n.rush-summary-dish {\n  overflow: hidden;\n  color: #344238;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  font-weight: 650;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rush-summary-qty {\n  grid-row: span 2;\n  align-self: center;\n  color: #9a6b1e;\n  font-size: calc(18px + var(--kds-font-delta, 0px));\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n}\n\n.rush-summary-breakdown {\n  color: #7b887e;\n  font-size: calc(10px + var(--kds-font-delta, 0px));\n}\n\n.rush-summary-state,\n.rush-summary-empty {\n  display: grid;\n  gap: 8px;\n  padding: 20px 14px;\n  color: #6c7a70;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n}\n\n.rush-summary-empty strong { color: #344238; }\n.rush-summary-empty span { line-height: 1.4; }\n.rush-summary-refresh { margin: 8px 14px; color: #718075; font-size: calc(10px + var(--kds-font-delta, 0px)); }\n\n.rush-summary-skeleton {\n  display: grid;\n  gap: 12px;\n  padding: 16px 14px;\n}\n\n.rush-summary-skeleton > div {\n  height: 35px;\n  border-radius: 6px;\n  background: linear-gradient(90deg, #e5eae2, #d8e1d7, #e5eae2);\n  background-size: 200% 100%;\n  animation: rush-skeleton 1.8s ease-in-out infinite;\n}\n\n.rush-board-wrap { display: flex; flex-direction: column; min-width: 0; min-height: 100%; }\n.rush-board-scroll {\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: visible;\n  overscroll-behavior-x: contain;\n  scrollbar-width: thin;\n  -webkit-overflow-scrolling: touch;\n}\n\n.rush-board {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(300px, 1fr));\n  align-items: start;\n  gap: 11px;\n  min-width: 0;\n  padding: 2px 2px 14px;\n}\n\n.rush-column {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 11px;\n  min-width: 0;\n}\n\n.rush-ticket {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  padding: 12px !important;\n  overflow: visible;\n  border: 1px solid #d9e0d8 !important;\n  border-radius: 10px !important;\n  background: #fffefa !important;\n  box-shadow: 0 3px 10px rgba(30, 44, 34, .07) !important;\n}\n\n.rush-ticket-header { display: grid; gap: 7px; }\n.rush-ticket-title { display: flex; align-items: center; flex-wrap: wrap; min-width: 0; gap: 7px; }\n.rush-ticket-number {\n  display: grid;\n  flex: 0 0 28px;\n  width: 28px;\n  height: 28px;\n  place-items: center;\n  border-radius: 7px;\n  background: #e2b96f;\n  color: #2d281c;\n  font-size: calc(15px + var(--kds-font-delta, 0px));\n  font-weight: 900;\n  font-variant-numeric: tabular-nums;\n}\n\n.rush-order-type {\n  min-width: 0;\n  color: #29382f;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-weight: 750;\n  overflow-wrap: anywhere;\n}\n\n.rush-edit-button {\n  display: grid;\n  flex: 0 0 28px;\n  width: 28px;\n  height: 28px;\n  margin-left: auto;\n  place-items: center;\n  border: 1px solid #d8e0d7;\n  border-radius: 7px;\n  background: transparent;\n  color: #66756a;\n  cursor: pointer;\n}\n\n.rush-edit-button svg { width: 15px; height: 15px; fill: none; stroke: currentColor; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }\n.rush-edit-button:hover { background: #edf2eb; color: #26372d; }\n.rush-edit-button:focus-visible,\n.rush-dish-action:focus-visible,\n.rush-pagination button:focus-visible { outline: 2px solid #e2b96f; outline-offset: 2px; }\n\n.rush-ticket-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 5px 8px;\n  color: #718075;\n  font-size: calc(10px + var(--kds-font-delta, 0px));\n}\n\n.rush-table-reference {\n  display: inline-flex;\n  min-width: 0;\n  padding: 3px 7px;\n  border: 1px solid #e0c88f;\n  border-radius: 6px;\n  background: #fbf3df;\n  color: #6b5122;\n  font-size: calc(10px + var(--kds-font-delta, 0px));\n  font-weight: 750;\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n}\n.rush-ticket .kds-order-timing { margin-top: 0; padding: 4px 6px; gap: 4px; border-radius: 6px; }\n.rush-ticket .kds-order-timing__label { font-size: calc(9px + var(--kds-font-delta, 0px)); }\n.rush-ticket .kds-order-timing__value { font-size: calc(16px + var(--kds-font-delta, 0px)); }\n.rush-ticket .kds-order-timing__prep { font-size: calc(8px + var(--kds-font-delta, 0px)); }\n.rush-ticket.kds-timing--green { border-left: 3px solid #38825d !important; }\n.rush-ticket.kds-timing--orange { border-left: 3px solid #c57a20 !important; }\n.rush-ticket.kds-timing--red { border-left: 3px solid #b02f34 !important; }\n.rush-ticket-dishes { margin-top: 5px; border-top: 1px dashed #d9e0d8; }\n\n.rush-dish { padding: 2px 0; border-bottom: 1px dashed #e0e5df; }\n.rush-dish-action {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 39px;\n  gap: 8px;\n  padding: 4px 5px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #2d3b32;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.rush-dish-action:hover:not(:disabled) { background: rgba(56, 91, 60, .07); }\n.rush-dish-action:disabled { cursor: default; }\n.rush-dish-name { flex: 1 1 auto; min-width: 0; line-height: 1.35; white-space: normal; overflow-wrap: anywhere; font-size: calc(12px + var(--kds-font-delta, 0px)); font-weight: 650; }\n.rush-dish-qty { flex: 0 0 auto; color: #67756b; font-size: calc(11px + var(--kds-font-delta, 0px)); font-weight: 700; }\n.rush-dish-state { flex: 0 0 auto; color: #637568; font-size: calc(9px + var(--kds-font-delta, 0px)); font-weight: 750; text-transform: uppercase; letter-spacing: .04em; }\n.rush-dish.is-ready .rush-dish-name { color: #7c917f; text-decoration: line-through; text-decoration-thickness: 1px; }\n.rush-dish.is-ready .rush-dish-state { color: #477b4c; }\n.rush-dish.is-terminal .rush-dish-name { color: #89948b; text-decoration: line-through; }\n.rush-dish-details { display: flex; flex-wrap: wrap; gap: 4px; padding: 3px 4px 1px; }\n.rush-detail-pill {\n  max-width: 100%;\n  box-sizing: border-box;\n  white-space: normal;\n  padding: 3px 6px;\n  border: 1px solid #dce3db;\n  border-radius: 5px;\n  color: #68766b;\n  font-size: calc(9px + var(--kds-font-delta, 0px));\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n}\n.rush-detail-pill.rush-note { border-color: #e3d6b7; color: #87652e; }\n\n/* Pinned to the bottom of the rush board: pushed down when tickets are few, sticky when they overflow. */\n.rush-pagination {\n  position: sticky;\n  bottom: 0;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: auto;\n  padding: 9px 3px 4px;\n  border-top: 1px solid #e0e5df;\n  background: #fff;\n  color: #6f7c72;\n  font-size: calc(11px + var(--kds-font-delta, 0px));\n}\n\n.rush-pagination > div { display: flex; align-items: center; gap: 9px; }\n.rush-pagination button {\n  min-height: 32px;\n  padding: 0 12px;\n  border: 1px solid #d4ddd3;\n  border-radius: 7px;\n  background: #f0f4ed;\n  color: #344238;\n  font: inherit;\n  font-weight: 700;\n  cursor: pointer;\n}\n.rush-pagination button:disabled { opacity: .4; cursor: not-allowed; }\n.rush-page-indicator { color: #526156; font-variant-numeric: tabular-nums; white-space: nowrap; }\n\n.rush-board-state {\n  display: grid;\n  align-content: center;\n  justify-items: center;\n  gap: 9px;\n  min-height: 240px;\n  color: #718075;\n  text-align: center;\n}\n.rush-board-state strong { color: #344238; font-size: calc(18px + var(--kds-font-delta, 0px)); }\n.rush-board-state span { font-size: calc(12px + var(--kds-font-delta, 0px)); }\n.rush-inline-error { display: flex; align-items: center; justify-content: space-between; padding: 6px 8px; color: #87652e; font-size: calc(11px + var(--kds-font-delta, 0px)); }\n.rush-board-loading { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: 11px; min-width: 0; }\n.rush-skeleton-column { display: grid; align-content: start; gap: 11px; }\n.rush-skeleton-ticket { height: 160px; border: 1px solid #d9e0d8; border-radius: 10px; background: linear-gradient(90deg, #f0f2ed, #e2e9e0, #f0f2ed); background-size: 200% 100%; animation: rush-skeleton 1.8s ease-in-out infinite; }\n@keyframes rush-skeleton { 0%, 100% { opacity: .62; } 50% { opacity: 1; } }\n\n.dark .rush-prep-summary,\n.dark .rush-ticket { color: #ecf2ee; }\n.dark .rush-prep-summary { border-color: #36433f; background: #202a28; box-shadow: 0 8px 22px rgba(10, 20, 17, .22); }\n.dark .rush-summary-header,\n.dark .rush-summary-accept { border-color: #374541; }\n.dark .rush-summary-eyebrow { color: #a8b9af; }\n.dark .rush-summary-header h2 { color: #f1f4ef; }\n.dark .rush-summary-total { border-color: #607466; background: #2b3932; color: #d9ebd9; }\n.dark .rush-summary-accept strong { color: #e8eee9; }\n.dark .rush-summary-accept span { color: #9eafa5; }\n.dark .rush-summary-accept button,\n.dark .rush-summary-state button,\n.dark .rush-inline-error button,\n.dark .rush-board-state button { border-color: #77947d; background: #34483a; color: #e8f2e8; }\n.dark .rush-summary-accept button:hover:not(:disabled),\n.dark .rush-summary-state button:hover,\n.dark .rush-inline-error button:hover,\n.dark .rush-board-state button:hover { background: #405a46; }\n.dark .rush-summary-row { border-color: #34413d; }\n.dark .rush-summary-dish { color: #e4ebe5; }\n.dark .rush-summary-qty { color: #f3d392; }\n.dark .rush-summary-breakdown { color: #9cac9f; }\n.dark .rush-summary-state,\n.dark .rush-summary-empty { color: #aab7ad; }\n.dark .rush-summary-empty strong { color: #dfe8e0; }\n.dark .rush-summary-refresh { color: #a6b4aa; }\n.dark .rush-summary-skeleton > div { background: linear-gradient(90deg, #2b3834, #35433e, #2b3834); background-size: 200% 100%; }\n.dark .rush-ticket { border-color: #435049 !important; background: #252f2c !important; box-shadow: 0 3px 10px rgba(5, 13, 10, .18) !important; }\n.dark .rush-order-type { color: #f0f2ec; }\n.dark .rush-edit-button { border-color: #4c5b53; color: #bac8bd; }\n.dark .rush-edit-button:hover { background: #34423b; color: #fff; }\n.dark .rush-ticket-meta { color: #aebbb1; }\n.dark .rush-table-reference {\n  border-color: #74613c;\n  background: #403824;\n  color: #f0d89f;\n}\n.dark .rush-ticket-dishes { border-color: #46554c; }\n.dark .rush-dish { border-color: #3d4a43; }\n.dark .rush-dish-action { color: #eff3ed; }\n.dark .rush-dish-action:hover:not(:disabled) { background: rgba(206, 224, 204, .08); }\n.dark .rush-dish-qty { color: #c0ccc2; }\n.dark .rush-dish-state { color: #a5b5a8; }\n.dark .rush-dish.is-ready .rush-dish-name { color: #91a796; }\n.dark .rush-dish.is-ready .rush-dish-state { color: #a6d2a9; }\n.dark .rush-dish.is-terminal .rush-dish-name { color: #87948b; }\n.dark .rush-detail-pill { border-color: #49574f; color: #b8c5ba; }\n.dark .rush-detail-pill.rush-note { border-color: #766347; color: #e0c799; }\n.dark .rush-pagination { border-color: #374541; background: #1b2422; color: #aab6ad; }\n.dark .rush-pagination button { border-color: #526258; background: #2b3731; color: #e4ebe5; }\n.dark .rush-page-indicator { color: #c7d0c8; }\n.dark .rush-board-state { color: #acb9af; }\n.dark .rush-board-state strong { color: #e8eee8; }\n.dark .rush-inline-error { color: #e2c28f; }\n.dark .rush-skeleton-ticket { border-color: #394841; background: linear-gradient(90deg, #242e2a, #303c36, #242e2a); background-size: 200% 100%; }\n\n@media (max-width: 1050px) {\n  .rush-prep-summary { flex-basis: 184px; }\n}\n\n@media (max-width: 700px) {\n  .kds-main-layout.kds-orders-layout:has(.rush-prep-summary),\n  .kds-main-layout.kds-tables-layout { flex-direction: column; overflow: hidden; }\n  .rush-prep-summary { flex: 0 0 auto; max-height: 180px; width: 100%; }\n  .rush-summary-header { padding: 9px 12px; }\n  .rush-summary-header h2 { font-size: calc(15px + var(--kds-font-delta, 0px)); }\n  .rush-summary-accept { padding: 8px 12px; }\n  .rush-summary-list { display: flex; gap: 12px; overflow-x: auto; overflow-y: hidden; padding: 0 12px 8px; }\n  .rush-summary-row { flex: 0 0 140px; border-bottom: 0; }\n  .rush-board { grid-template-columns: repeat(2, minmax(300px, 1fr)); min-width: max-content; width: 100%; }\n  .rush-board-loading { grid-template-columns: repeat(2, minmax(205px, 1fr)); min-width: max-content; }\n  .rush-pagination { align-items: flex-start; flex-direction: column; }\n  .rush-pagination > div { width: 100%; justify-content: space-between; }\n}\n\n@media (max-width: 700px) {\n  .kds-main-layout.kds-orders-layout {\n    flex-direction: row;\n    overflow: hidden;\n    gap: 8px;\n  }\n  .kds-main-layout.kds-orders-layout .left-bar-kds {\n    flex: 0 0 min(38vw, 280px);\n    width: min(38vw, 280px);\n    min-height: 0;\n  }\n  .kds-main-layout.kds-orders-layout .kds-orders-container {\n    flex: 1 1 0;\n    width: auto;\n    min-width: 0;\n  }\n  .kds-main-layout.kds-orders-layout .left-bar-kds.is-collapsed {\n    flex: 0 0 58px;\n    width: 58px;\n  }\n}\n\n/* Pending disclosure gives the Processing column all remaining width. */\n.kds-main-layout.kds-orders-layout {\n  justify-content: flex-start;\n  min-width: 0;\n}\n\n.kds-main-layout.kds-orders-layout > .left-bar-kds.is-collapsed {\n  flex-basis: 66px;\n}\n\n.kds-main-layout.kds-orders-layout > .kds-orders-container {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n@media (max-width: 700px) {\n  .kds-main-layout.kds-orders-layout > .left-bar-kds {\n    flex: 0 0 min(38vw, 280px);\n    width: min(38vw, 280px);\n  }\n\n  .kds-main-layout.kds-orders-layout > .left-bar-kds.is-collapsed {\n    flex-basis: 58px;\n    width: 58px;\n  }\n\n  .kds-main-layout.kds-orders-layout > .kds-orders-container {\n    flex: 1 1 0;\n    width: auto;\n    min-width: 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .kds-main-layout.kds-orders-layout > .left-bar-kds {\n    transition: none;\n  }\n}\n\n/* Rush queue interactions: dish and whole-ticket completion controls. */\n.rush-ticket-header {\n  position: relative;\n  min-width: 0;\n}\n\n.rush-ticket-complete {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.rush-ticket-complete:disabled { cursor: default; }\n.rush-ticket-complete:not(:disabled):hover .rush-ticket-title { color: #41694b; }\n.rush-ticket-complete:focus-visible,\n.rush-edit-button:focus-visible,\n.rush-dish-action:focus-visible,\n.rush-summary-selectable:focus-visible {\n  outline: 3px solid #bd8738;\n  outline-offset: 3px;\n}\n\n.rush-ticket-header-content { display: grid; gap: 7px; }\n.rush-ticket-header-content > .rush-ticket-title { padding-right: 36px; }\n.rush-ticket-countdown { display: block; }\n.rush-ticket-busy {\n  justify-self: start;\n  color: #815f2b;\n  font-size: calc(10px + var(--kds-font-delta, 0px));\n  font-weight: 750;\n}\n.rush-edit-button {\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  right: 0;\n  margin: 0;\n}\n\n.rush-ticket.is-highlighted {\n  outline: 3px solid #b9822f;\n  outline-offset: 2px;\n}\n.rush-highlight-badge {\n  justify-self: start;\n  padding: 3px 7px;\n  border: 1px solid #d2a24f;\n  border-radius: 999px;\n  background: #fbf0d4;\n  color: #63491e;\n  font-size: calc(9px + var(--kds-font-delta, 0px));\n  font-weight: 800;\n  letter-spacing: .04em;\n  text-transform: uppercase;\n}\n.rush-highlight-empty {\n  margin: 2px 2px 9px;\n  padding: 9px 11px;\n  border: 1px solid #e0c88f;\n  border-radius: 8px;\n  background: #fbf3df;\n  color: #6b5122;\n  font-size: calc(11px + var(--kds-font-delta, 0px));\n  line-height: 1.4;\n}\n\n.rush-summary-selectable {\n  width: 100%;\n  border: 0;\n  border-bottom: 1px solid #dfe5de;\n  border-radius: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n.rush-summary-selectable:hover,\n.rush-summary-selectable.is-selected {\n  background: #f4f0e4;\n}\n.rush-summary-selectable.is-selected {\n  box-shadow: inset 3px 0 #b9822f;\n}\n\n.dark .rush-ticket-complete:not(:disabled):hover .rush-ticket-title { color: #d6e7cc; }\n.dark .rush-ticket-busy { color: #e0c799; }\n.dark .rush-ticket.is-highlighted { outline-color: #d9ad59; }\n.dark .rush-highlight-badge {\n  border-color: #8b7040;\n  background: #403824;\n  color: #f0d89f;\n}\n.dark .rush-highlight-empty {\n  border-color: #766347;\n  background: #403824;\n  color: #e0c799;\n}\n.dark .rush-summary-selectable:hover,\n.dark .rush-summary-selectable.is-selected { background: #2e3a33; }\n.dark .rush-summary-selectable.is-selected { box-shadow: inset 3px 0 #d9ad59; }\n.dark .rush-summary-selectable { border-bottom-color: #34413d; }\n\n@media (max-width: 520px) {\n  .rush-ticket { padding: 10px !important; }\n  .rush-ticket-header-content > .rush-ticket-title { padding-right: 34px; }\n  .rush-ticket-meta { gap: 4px 6px; }\n}\n\n/* Inline spinner inside buttons waiting on an API call */\n.loader.kds-btn-loader {\n  width: 12px;\n  height: 12px;\n  margin-right: 6px;\n  vertical-align: -2px;\n  flex: 0 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
